
/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/forwardcommandunits.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
//import Bing from '../../actions/ReeferMap.js';
//import * as ReeferMapjs from '../../actions/ReeferMap.js';
//var Bing = ReeferMapjs.default;
import ReeferCallout from '../../actions/ReeferCallout';
import 'ag-grid-enterprise';
import { RCUtils } from './../../RCUtils';
import { ReeferHistoryGrid } from './ReeferHistoryGrid';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';//RCNG 146
import ExportToExcel, * as Exceljs from '../../actions/ExportToExcel.js';
import $ from 'jquery';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-dark.css';
import '../../../node_modules/react-toggle-switch/dist/css/switch.min.css';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';
import { PingControl } from './../sharedcomponents/ForwardCommands/PingControl';
import { TempSetPoint } from './../sharedcomponents/ForwardCommands/TempSetPoint';
import { HumiditySetPoint } from './../sharedcomponents/ForwardCommands/HumiditySetPoint';
import { O2SetPoint } from './../sharedcomponents/ForwardCommands/O2SetPoint';
import { ReeferToggleButtonsFilter } from '../childcomponents/ReeferToggleButtonsFilter';
import { CO2SetPoint } from './../sharedcomponents/ForwardCommands/CO2SetPoint';
import { ChangeReeferId } from './../sharedcomponents/ForwardCommands/ChangeReeferId';
import { ChangeReportingInterval } from './../sharedcomponents/ForwardCommands/ChangeReportingInterval';
import { ChangeDataLogInterval } from './../sharedcomponents/ForwardCommands/ChangeDataLogInterval';
import { AssignPANID } from './../sharedcomponents/ForwardCommands/AssignPANID';
import { RebootReeferController } from './../sharedcomponents/ForwardCommands/RebootReeferController';
import { VerifyModelValidity } from './../sharedcomponents/ForwardCommands/VerifyModelValidity';
import { SyncReeferClock } from './../sharedcomponents/ForwardCommands/SyncReeferClock';
import { StartDeforst } from './../sharedcomponents/ForwardCommands/StartDeforst';
import { ChangeDeforstInterval } from './../sharedcomponents/ForwardCommands/ChangeDeforstInterval';
import { TraditionalDataDownload } from './../sharedcomponents/ForwardCommands/TraditionalDataDownload';
import { StopPTI } from './../sharedcomponents/ForwardCommands/StopPTI';
import { ScheduledPreTrip } from './../sharedcomponents/ForwardCommands/ScheduledPreTrip';
import { PreTrip } from './../sharedcomponents/ForwardCommands/PreTrip';
import { LastPretripResult } from './../sharedcomponents/ForwardCommands/LastPretripResult';
import { QueryReeferInventory } from './../sharedcomponents/ForwardCommands/QueryReeferInventory';
import { UpdateModelConfiguration } from './../sharedcomponents/ForwardCommands/UpdateModelConfiguration';
import { ChangeReeferClockSyncSetting } from './../sharedcomponents/ForwardCommands/ChangeReeferClockSyncSettings';
import { ChangeZigbeeSettings } from './../sharedcomponents/ForwardCommands/ChangeZigbeeSettings';
import { AutoConfiguration } from './../sharedcomponents/ForwardCommands/AutoConfiguration';
import { AssetConfiguration } from './../sharedcomponents/ForwardCommands/AssetConfiguration';
import { GuestReeferConfiguration } from './../sharedcomponents/ForwardCommands/GuestReeferConfiguration';
import { AssignBookingSystem, UnAssignBookingSystem, EditBookingSystem } from '../sharedcomponents/BookingSystem';
import { MultipleSetpoints } from './../sharedcomponents/ForwardCommands/MultipleSetpoints';
import { AutomaticColdTreatment } from './../sharedcomponents/ForwardCommands/AutomaticColdTreatment';
import { GetFreshAirType } from './../sharedcomponents/ForwardCommands/GetFreshAirType';
import { SetFreshAirType } from './../sharedcomponents/ForwardCommands/SetFreshAirType';
import { PopupConfirm } from './../sharedcomponents/PopupConfirm';
import { UnassignReefersFromCustomer } from '../childcomponents/UnassignReefersFromCustomer';
import { AssignToCustomer } from '../childcomponents/AssignToCustomer';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridReeferStatusToolBar } from '../sharedcomponents/GridReeferStatusToolBar';
import { CreateTrip } from '../childcomponents/CreateTrip';
import { TripStatus } from '../childcomponents/TripStatus';
import { TripDeviation } from '../childcomponents/TripDeviation';
import UserRights from '../../actions/UserRights';
import CommonActions from '../../actions/CommonActions';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { ControlledAtmosphere } from './../sharedcomponents/ForwardCommands/ControlledAtmosphere';
import { DeviceReset } from './../sharedcomponents/ForwardCommands/DeviceReset';
import { DeviceHardReset } from './../sharedcomponents/ForwardCommands/DeviceReset';
import { ReeferGetAssetId } from './../sharedcomponents/ForwardCommands/ReeferGetAssetId';
import { EnableDoorSensor } from './../sharedcomponents/ForwardCommands/EnableDoorSensor';
import  CCAlmTooltip  from '../sharedcomponents/GridToolTips/CCAlmTooltip';
import { ExportToExcelConfirmationWindow } from '../sharedcomponents/ExportToExcelConfirmationWindow';
import { EmailControlExcelPreference } from '../sharedcomponents/EmailControlExcelPreference';
import { TripWiseReport } from './../sharedcomponents/ForwardCommands/TripWiseReport';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import lodashfilter from 'lodash/filter';
import isEqual from 'lodash/isEqual';
import { NewBookingUnAssign } from '../sharedcomponents/NewBookingUnAssign';
import { ViewBookingDetails } from '../childcomponents/ViewBookingDetails';
import { EditVoyageVVC } from '../childcomponents/EditVoyageVVC';
import { DimiSetting } from './../sharedcomponents/ForwardCommands/DIMISettings';
import { IntelligentPTIFunction } from './../sharedcomponents/ForwardCommands/IntelligentPTIFunction';
import { FanSpeed } from './../sharedcomponents/ForwardCommands/FanSpeed';
var Config: any = require('../../Config.json');
var Excel = Exceljs.default;

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

var functionId;
var previousReeferid;
interface ReeferGridState {
    loading: boolean;
    Filters: server.ReeferSearchFilters;
    rowData: any[];
    columnDefs: any[];
    selectedItems: any[];
    overlayLoadingTemplate: any;
    modelTitle: string;
    popUpHtml: any;
    isChangeDeforstInterval: boolean;
    pretripCmd: string;
    reeferFormatter: any;
    pageSize: any;
    gridApiParams: any;
    tempFilters: server.ReeferSearchFilters;
    exportFields: ExportFields;
    ToggleSearchParams: any;
    VCCheckBoxInfo: VCCheckBoxData;
    PTReport: string;
    ReportReeferId: string;
    modelTitleReport: string;
    popUpHtmlReport: any;
    isStarCoolOem: boolean;
    CustomAttributes: server.CustomAttributes[];
    CustomerSpecificCommandData: any;
    fullPreTripCommandText: string;
    shortPreTripCommandText: string;
    funcPreTripCommandText: string;
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    TWReport: string;
    rowModelname: string;
    serverSideStoreType: any;
    showServerSideGrid: boolean;
    IsEnableServerSide: boolean;
    PrevEndRow: any;
    PrevStartRow: any;
    CargoCareProfiles: any[];
     frameworkComponents: any;
}

class ExportFields {
    ExportData: string;
}

var currentMousePos = { x: -1, y: -1 };
var self;
var selectedRowData;
var coppiedData;
var coppiedDataWithHeader;
var customerTypeCd;
var custId;
var userEmail;
var dCXDownloads;
var customerAccessData: any[];
var viewBookingData: any[];
var columnDefs2: any[];
var columnDefs: any[];
var commandIssued: boolean = false;
let groupingDisabled = false;
var reeferAssetSensors: any[];
var serverSideEnabled: any;
var selectedRowIndex: number;
var IsTriggered: boolean;
var EnableLynxCommands: boolean;
var EnableCT35ML5Commands: boolean; //RCNG-3425
var ShowTDDForCT36ML5: boolean;
var ShowTDDForCT35ML5: boolean;
var tripWISESupport: any;
export class ReeferStatusSSRMGrid extends React.Component<any, ReeferGridState> {
    constructor(props: any) {
        super(props);

        customerAccessData = [];
        viewBookingData = [];
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;//this.props.loggedInUserData.User.Customer.CustomerTypeCd;
        custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;//this.props.loggedInUserData.User.Customer.CustomerId;
        userEmail = JSON.parse(sessionStorage.getItem('UserInfo')).UserEmail;
        //serverSideEnabled =JSON.parse(sessionStorage.getItem('UserInfo')).ServerSideEnabled;
        serverSideEnabled = JSON.parse(sessionStorage.getItem('SSRM')) == true ? true : false;
        dCXDownloads = JSON.parse(sessionStorage.getItem('customerDetails')).DCXDownloads;
        functionId = 41; // functionId for ReeferStatus Grid
        var commandSpecificData: server.CommandSpecificData = { commandId: '', Oem: [] };

        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var exportData = new ExportFields();
        this.state = {
            loading: true,
            Filters: this.props.statusFilter,
            //rowData: serverSideEnabled ? [] : this.props.propsReeferData,
            rowData: [],//this.props.propsReeferData,
            columnDefs: [],
            selectedItems: [],
            overlayLoadingTemplate: overlayTemplate,
            modelTitle: '',
            popUpHtml: '',
            isChangeDeforstInterval: false,
            pretripCmd: null,
            reeferFormatter: this.props.propsReeferFormatterData,
            tempFilters: null,
            pageSize: 250,
            gridApiParams: [],
            exportFields: exportData,
            ToggleSearchParams: null,
            VCCheckBoxInfo: emptyVCCheckBoxData,
            PTReport: '',
            ReportReeferId: '',
            modelTitleReport: '',
            popUpHtmlReport: '',
            isStarCoolOem: false,
            CustomAttributes: [],
            CustomerSpecificCommandData: commandSpecificData,
            fullPreTripCommandText: 'Full',
            shortPreTripCommandText: 'Short',
            funcPreTripCommandText: 'Function Test',
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            IsCommandIssued: false,
            PrevSelectedItems: [],
            autoGroupColumnDef: { minWidth: 200 },
            TWReport: '',
            rowModelname: 'serverSide',
            serverSideStoreType: 'partial',
            showServerSideGrid: JSON.parse(sessionStorage.getItem('SSRM')) == true ? true : false,
            IsEnableServerSide: JSON.parse(sessionStorage.getItem('SSRM')) == true ? true : false,
            PrevEndRow: -1,
            PrevStartRow: -1,
            CargoCareProfiles: [],
            frameworkComponents: { cCAlmTooltip: CCAlmTooltip},
        };
        //RCNG-3056
        var refAppParams = this.props.refApplicationParams;
        if (refAppParams != null && refAppParams != undefined) {
            if (refAppParams.EnableLynxCommands != null && refAppParams.EnableLynxCommands != undefined)
                EnableLynxCommands = refAppParams.EnableLynxCommands == 'true' ? true : false;
            if (refAppParams.EnableCT35ML5Commands != null && refAppParams.EnableCT35ML5Commands != undefined)
                EnableCT35ML5Commands = refAppParams.EnableCT35ML5Commands == 'true' ? true : false;
            if (refAppParams.ShowTDDForCT36ML5 != null && refAppParams.ShowTDDForCT36ML5 != undefined)
                ShowTDDForCT36ML5 = refAppParams.ShowTDDForCT36ML5 == 'true' ? true : false;
            if (refAppParams.ShowTDDForCT35ML5 != null && refAppParams.ShowTDDForCT35ML5 != undefined)
                ShowTDDForCT35ML5 = refAppParams.ShowTDDForCT35ML5 == 'true' ? true : false;
        }
        tripWISESupport = this.props.tripWISESupportdeviceTypes;
        //RCNG-713
        this.GetCCprofileCode();
        self = this;
    }

    GetCCprofileCode() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfiles');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ CargoCareProfiles: data });
            });
    }

    toolTipValueGetter = (params) => ({ value: params.value });
    renderCustomAttributesColumns() {
        columnDefs = this.createColumnDefs();

        if (this.props.customerDeviceTypeSensor != null && this.props.customerDeviceTypeSensor != undefined)
            reeferAssetSensors = this.props.customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'R');

        var newColumns = columnDefs;

        if (JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable) {
            //columnDefs2 = columnDefs;
            var generatedColumns = [];
            //WI 26721 First Device sensors and next Custom attributes
            if (reeferAssetSensors != null && reeferAssetSensors != undefined && reeferAssetSensors.length > 0) {
                $.each(reeferAssetSensors, function (i, val) {
                    var customerDeviceTypeSensorObject: any;
                    if (val.SensorTypeCd.trim() == "T")
                        customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: false, sortable: false, resizable: true, cellClass: 'OneDecimal', headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                    else
                        customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: false, sortable: false, resizable: true, cellClass: 'OneDecimal', valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                    var columnHeaderName = val.ColumnNm;
                    var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                    customerDeviceTypeSensorObject.headerName = columnHeaderName;
                    customerDeviceTypeSensorObject.field = columnFieldName;

                    generatedColumns.push(customerDeviceTypeSensorObject);
                });

                var newSensorColumnDefination = {
                    headerName: "Device Sensor(s)",
                    children: generatedColumns
                };
                if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                    newColumns.push(newSensorColumnDefination);
                //this.setState({ columnDefs: newColumns });

                if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                    columnDefs2.push(newSensorColumnDefination);// = newColumns;
            }

            if (this.props.CustomAttributes != null && this.props.CustomAttributes != undefined && this.props.CustomAttributes.length > 0) {
                var generatedColumns = [];
                $.each(this.props.CustomAttributes, function (i, val) {
                    var customAttributeObject = { headerName: '', field: '', enableRowGroup: false, sortable: false, filter: false, resizable: true, valueGetter: Formatters.stringTypeSortingForCustomefields, cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130, onCellClicked: self.onCellClickedCopy.bind(this) };
                    var attributeName = val.AttributeName;
                    var columnHeaderName = attributeName.replace(' ', '');
                    customAttributeObject.headerName = attributeName;
                    customAttributeObject.field = columnHeaderName;
                    generatedColumns.push(customAttributeObject);
                });

                var newColumnDefination = {
                    headerName: "Asset Attributes",
                    children: generatedColumns
                };
                if (!newColumns.some(x => x.headerName === "Asset Attributes"))
                    newColumns.push(newColumnDefination);
                //this.setState({ CustomAttributes: this.props.CustomAttributes });
                this.setState({ columnDefs: newColumns });

                if (!columnDefs2.some(x => x.headerName === "Asset Attributes"))
                    columnDefs2.push(newColumnDefination);// = newColumns;
            }
          
            this.setState({ columnDefs: newColumns });
        }
        else {
            //columnDefs2 = columnDefs;         
            var generatedColumns = [];

            if (reeferAssetSensors != null && reeferAssetSensors != undefined && reeferAssetSensors.length > 0) {
                $.each(reeferAssetSensors, function (i, val) {
                    var customerDeviceTypeSensorObject: any;
                    if (val.SensorTypeCd.trim() == "T")
                        customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, filter: false, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                    else
                        customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, filter: false, resizable: true, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                    var columnHeaderName = val.ColumnNm;
                    var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                    customerDeviceTypeSensorObject.headerName = columnHeaderName;
                    customerDeviceTypeSensorObject.field = columnFieldName;
                    generatedColumns.push(customerDeviceTypeSensorObject);
                });

                var newSensorColumnDefination = {
                    headerName: "Device Sensor(s)",
                    children: generatedColumns
                };
                if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                    newColumns.push(newSensorColumnDefination);
                this.setState({ columnDefs: newColumns });

                if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                    columnDefs2.push(newSensorColumnDefination);// = newColumns;
            }

            this.setState({ columnDefs: newColumns });
        }
    }

    componentWillReceiveProps(nextprops: any) {
        const propsReeferData: any = this.props.propsReeferData;
        if (propsReeferData !== nextprops.propsReeferData)
            this.setState({ rowData: [] });

        

        if (nextprops.propsReeferData != null && nextprops.propsReeferData != undefined && nextprops.propsReeferData.length > 0 && nextprops.statusFilter.StatusFilters != undefined
            && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.DryInGeofence && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.DryOutGeofence
            && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.PowerOffNotReporting && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.PowerOffReporting
            && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.PowerOnNotReporting && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.PowerOnReporting
            && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.ChassisPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.ChassisPwrOutGeofence
            && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.ChassisNotPwrInGeofence && nextprops.statusFilter.StatusFilters[0] != GensetAndDryAndChassisStatusEnum.ChassisNotPwrOutGeofence) {

            if (!serverSideEnabled)
                this.setState({ rowData: nextprops.propsReeferData });
           
            if (self.state.ToggleSearchParams != null && self.state.ToggleSearchParams != undefined) {
                self.filterReeferStatusGrid(self.state.ToggleSearchParams);
            }
        }

        if (nextprops.propsReeferData != null && nextprops.propsReeferData != undefined && nextprops.propsReeferData.length > 0) {
            self.props.getReeferStatusGridRows(nextprops.propsReeferData.length);
        } else if (nextprops.propsReeferData != null && nextprops.propsReeferData != undefined && nextprops.propsReeferData.length === 0) {
            self.props.getReeferStatusGridRows(0);
        }

        if (nextprops.propsReeferFormatterData != null && nextprops.propsReeferFormatterData != null) {
            if (nextprops.propsReeferFormatterData.AlarmMasterList != null && nextprops.propsReeferFormatterData.AlarmMasterList != undefined && nextprops.propsReeferFormatterData.AlarmMasterList.length > 0) {
                if (nextprops.propsReeferData.length > 0) {
                    if (self.state.gridApiParams != null && self.state.gridApiParams != undefined) {
                        if (typeof self.state.gridApiParams.hideOverlay !== "undefined") {
                            self.state.gridApiParams.hideOverlay();
                        }
                    }
                }
                else {
                    if (self.state.gridApiParams != null && self.state.gridApiParams != undefined) {
                        if (typeof self.state.gridApiParams.showNoRowsOverlay !== "undefined") {
                            self.state.gridApiParams.showNoRowsOverlay();
                        }
                    }
                }
            }
        }

        if (nextprops.performCargoAction) {
            self.props.getSelectedRow(self.state.selectedItems);
            $('#globalLoader').show();
        }

    }

    componentDidMount() {

        this.setState({ rowData: [] });
        columnDefs2 = this.createColumnDefs();
        setTimeout(() => {
            this.renderCustomAttributesColumns();
        }, 1000);
        //columnDefs = this.createColumnDefs();

        //this.setState({ columnDefs: columnDefs });

        //var functionID = 1;
        //var url = Config.ApiBaseUrl + '/api/User/GetDefaultSearchParams?FunctionId=' + functionID;
        //var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<server.UserPreferenceData>)
        //    .then(data => { 
        //        if (data != null && data != undefined) {
        //            if (!data.DefaultSearch)
        //                this.props.requestReeferAdvanceSearch(this.state.Filters);
        //        }
        //        else {
        //            this.props.requestReeferAdvanceSearch(this.state.Filters);
        //        }
        //    });
        //this.props.requestReeferAdvanceSearch(this.state.Filters);
        self.setState({ tempFilters: this.state.Filters });
        $('.ag-column-hover').contextmenu(function (e) {
            var relX = e.pageX - $('.ag-column-hover').offset().left;
            var relY = (e.pageY - $('.ag-column-hover').offset().top);
            $("#context-menu").toggle(100).css({
                top: relY,
                left: relX
            });
            $("#contextmenu").hide();
            e.preventDefault();
        });
       
       
        
        
        $(document).mousemove(function (event) {
            currentMousePos.x = event.pageX;
            currentMousePos.y = event.pageY;
            event.preventDefault();
        });
        Excel.draggableModalPopup(document.getElementById("contextMenuModel"));
        Excel.draggableModalPopup(document.getElementById("contextMenuModelReport"));
        Excel.draggableModalPopup(document.getElementById("contextMenuModelReportTW"));
    }

    setCommandText(Oem: any) {
        var url = '/api/reeferstatus/GetCustomerSpecificCommandLabel';
        var input = JSON.stringify(Oem);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + url, { method: 'POST', body: input, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    fullPreTripCommandText: data[0] != 'disabled' ? data[0] : 'Full',
                    shortPreTripCommandText: data[1] != 'disabled' ? data[1] : 'Short',
                    funcPreTripCommandText: data[2] != 'disabled' ? data[2] : 'Function Test'
                });
                //if (data[0] == 'disabled') {
                //    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').addClass('disabled');
                //    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('enabled');
                //}
                //else {
                //    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').removeClass('disabled');
                //    if ($("#liFullPreTripRequiresRight").hasClass("show")) $('#liFullPreTripRequiresRight').addClass('enabled');
                //}
                //if (data[1] == 'disabled') {
                //    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').addClass('disabled');
                //    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('enabled');
                //}
                //else {
                //    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').addClass('enabled');
                //    if ($("#liStartPreTripShortRequiresRight").hasClass("show")) $('#liStartPreTripShortRequiresRight').removeClass('disabled');
                //}

                //if (data[2] == 'disabled') {
                //    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('disabled');
                //    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('enabled');
                //}
                //else {
                //    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').addClass('enabled');
                //    if ($("#liStartPreTripFtRequiresRight").hasClass("show")) $('#liStartPreTripFtRequiresRight').removeClass('disabled');
                //}
            });
    }



    getCommandWindowText(Oem: any[], command: string) {
        var url = '/api/reeferstatus/GetCustomerSpecificCommandData';
        this.state.CustomerSpecificCommandData.Oem = Oem;
        this.state.CustomerSpecificCommandData.commandId = command;
        var input = JSON.stringify(this.state.CustomerSpecificCommandData);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + url, { method: 'POST', body: input, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "Selected Reefers must have a valid OEM type." || data == "Selected Reefers must have a Same OEM type.") {
                    PopupWindow.showErrorMessage("Alert", data);
                }
                else
                    this.setState({ pretripCmd: command, modelTitle: data }, () => self.RenderContextMenuPopUp('PreTrip', true));
            });
    }

    onRefreshData = () => {
        $('#globalLoader').show();
        this.setState({
            rowData: this.state.rowData
        });

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }

        $('#globalLoader').hide();
    };

    static reloadgrid() {

        self.setState({
            showServerSideGrid: JSON.parse(sessionStorage.getItem('SSRM')) == true ? true : false
        });
        self.forceUpdate();
    }
    static GetReeferStatusGridSSRMDataCount() {
        if (self.state.rowData != null && self.state.rowData != undefined && self.state.rowData != [] && self.state.rowData.length > 0) {
            return self.state.rowData.length;
        }
    }
    createServerSideDatasource(server) {
        return {
            getRows: function (params) {

                setTimeout(function () {

                    params.success({
                        rowData: [],
                        rowCount: 0,
                    });
                }, 100);
            },
        };
    }
    static ClearReeferStatusGridData() {
        if (self != undefined) {
            //ReeferCallout.ResetMapPushpins();
            selectedRowIndex = -1;
            var datasource = self.createServerSideDatasource();
            self.state.gridApiParams.setServerSideDatasource(datasource);
            self.state.gridApiParams.showNoRowsOverlay();
            self.setState({
                rowData: [],
                loading: false
            });

            if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
                if (typeof self.state.gridApiParams.paginationGoToFirstPage() != "undefined")
                    self.state.gridApiParams.paginationGoToFirstPage();
            }
        }
    }

    
    reeferContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Map": this.reefermapAction(this.state.selectedItems, 'Home');
                break;
            case "History": this.reeferhistoryAction(this.state.selectedItems, 'Home');
                break;
            case "CommandStatus": this.reefercommandstatusAction(this.state.selectedItems);
                break;
            case "Details": this.reeferdetailsAction(this.state.selectedItems, 'Reefer', 'CurrentDetails');
                break;
            case "Copy": this.reeferdetailsCopyAction();
                break;
            case "CopyWithHeader": this.reeferdetailsCopyWithHeaderAction();
                break;
            case "EditBooking": this.reeferBookingAction(this.state.selectedItems, 'SSRMReeferStatusGrid');
                break;
            case "CreateBooking": this.reeferCreateBookingAction(this.state.selectedItems, 'SSRMReeferStatusGrid');
                break;
            case "ViewBooking": this.reeferViewBookingAction(this.state.selectedItems, 'ReeferStatusGrid');
                break;
        }
    }

    reeferdetailsCopyAction() {
        var result = this.copyToClipboard(coppiedData);
    }

    reeferdetailsCopyWithHeaderAction() {
        var result = this.copyToClipboard(coppiedDataWithHeader);
    }
    reeferBookingAction(data: any, isOpenVia: any) {
        var reeferdetails = {
            reeferData: data, formname: isOpenVia
        };
        this.props.reeferbookingAction(reeferdetails);
    }
    reeferCreateBookingAction(data: any, isOpenVia: any) {
        var reeferdetails = {
            reeferData: data, formname: isOpenVia
        };
        this.props.reefercreatebookingAction(reeferdetails);
    }
    reeferViewBookingAction(data: any, isOpenVia: any) {
        var reeferdetails = {
            reeferData: data, formname: isOpenVia
        };
        this.props.reeferViewbookingAction(reeferdetails);
    }
    copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    onCellClickedCopy(event) {
        //coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        //coppiedData = event.value;
        var isHistoryCall = false;

        var isHistorySelectionChanged = false; 
        if (this.state.selectedItems.length == 1 && previousReeferid != event.data.ReeferID)
            isHistorySelectionChanged = true;

        if ((selectedRowIndex != event.rowIndex) || (isHistorySelectionChanged == true)) {
            selectedRowIndex = event.rowIndex;
            isHistoryCall = true;
        }
        if (event.data != null && event.data != undefined) {
            self.props.getLastSelectedRow(event.data);
            //$('#globalLoader').show();
            if (event.colDef.headerName === "Comments" && event.value === 0)
                this.reeferdetailsAction(this.state.selectedItems, 'Reefer', 'Comments');
            else if (isHistoryCall)
                ReeferHistoryGrid.ApplyReeferHistorySearch(event.data, false, self.props.reeferHistoryEnabled);
        }
        if (this.state.selectedItems.length == 1) 
            previousReeferid = event.data.ReeferID;
    }

    columnRowGroupChanged(params: any) {
        self.clearGridRowSelection(params);
    }



    onRowDataChanged(params: any): void {
        var reeferIdSelected = "";
        if (self.state.IsCommandIssued && self.state.PrevSelectedItems.length > 0) {
            //var selItems = self.state.PrevSelectedItems;
            reeferIdSelected = self.state.PrevSelectedItems[0].ReeferID;
            // reeferIdSelected = "TEST0000540";
        }
        commandIssued = false;
        var TotalCount = 0;
        var PageSize = self.state.pageSize;
        var TempCount = 0;
        var gridData = self.state.rowData;
        if (gridData != null && gridData != undefined && gridData.length > 0) {
            TotalCount = gridData.length;
            params.api.setFunctionsReadOnly(false);
        } else {
            params.api.setFunctionsReadOnly(true);
        }
        if (TotalCount > 0 && reeferIdSelected !== "") {
            let count = 0;
            if (reeferIdSelected) {
                commandIssued = true;
                params.api.forEachLeafNode((node) => {
                    count = count + 1;
                    if (node.data.ReeferID === reeferIdSelected) {
                        TempCount = count;
                        var pageNo = Math.ceil((TempCount / PageSize));
                        var setPageNum = pageNo - 1;
                        params.api.paginationGoToPage(setPageNum);
                        var currentParent = node.parent;
                        while (currentParent) {
                            currentParent.setExpanded(true);
                            currentParent = currentParent.parent;
                        }
                        node.setExpanded(true);
                        node.setSelected(true);
                        self.setState({ IsCommandIssued: false });
                        return;
                    }
                });
            }
        }
    }

    UpdateIsCommandIssued(IsCmdIssued: any) {
        self.setState({ IsCommandIssued: IsCmdIssued });
    }
    UpdatePrevSelectedItems(prevSelectedItems: any) {
        self.setState({ PrevSelectedItems: prevSelectedItems });
    }

    reeferdetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var reeferdetails = data;
        this.props.reeferdetailsAction(reeferdetails, self.state.reeferFormatter, dataSource, isOpenVia);
    }

    reeferhistoryAction(data: any, isOpenVia: any) {
        //var reeferdetails = data;
        var reeferdetails = {
            reeferData: data, ReeferenceData: self.state.reeferFormatter, isOpenVia: isOpenVia
        };
        this.props.reeferhistoryAction(reeferdetails);
    }

    reefermapAction(data: any, isOpenVia: any) {
        //var reeferdetails = data;
        var reeferdetails = {
            reeferData: data, ReeferenceData: self.state.reeferFormatter, isOpenVia: isOpenVia
        };
        this.props.reeferMapAction(reeferdetails);
    }

    reefercommandstatusAction(data: any) {
        var reeferdetails = data;
        this.props.reefercommandstatusAction(reeferdetails);
    }

    static SelectCurrentReefer(currentReefer: any) {
        self.state.gridApiParams.deselectAll();
        ReeferHistoryGrid.ClearHistoryGridData();
        var countRecordPerPage = 0;
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.forEachLeafNode(function (node) {
            countRecordPerPage = countRecordPerPage + 1;
            if (node.data.ReeferID === currentReefer.ReeferID) {
                var currentPage = Math.trunc(countRecordPerPage / self.state.gridApiParams.paginationProxy.pageSize);
                if (currentPage > 1) {
                    self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.paginationGoToPage(currentPage);
                }

                node.setSelected(true);
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureIndexVisible(node.rowIndex);
                self.setState({ selectedItems: node.data });
                self.props.getLastSelectedRow(node.data);
                //$('#globalLoader').show();
                ReeferHistoryGrid.ApplyReeferHistorySearch(node.data, true, self.props.reeferHistoryEnabled);
            }
        });
    }

    static ShowCurrentPTRSelectedReefer(currentReefer: any) {
        self.state.gridApiParams.deselectAll();
        ReeferHistoryGrid.ClearHistoryGridData();
        var countRecordPerPage = 0;
        var PTRReeferFound = false;
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachLeafNode(function (node) {
            countRecordPerPage = countRecordPerPage + 1;
            if (node.data.ReeferID === currentReefer.ReeferID) {
                var currentPage = Math.trunc(countRecordPerPage / self.state.gridApiParams.paginationProxy.pageSize);
                if (currentPage > 1) {
                    self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.paginationGoToPage(currentPage);
                }

                node.setSelected(true);
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.ensureIndexVisible(node.rowIndex);
                self.setState({ selectedItems: node.data });
                self.props.getLastSelectedRow(node.data);
                //$('#globalLoader').show();
                ReeferHistoryGrid.ApplyReeferHistorySearch(node.data, true, self.props.reeferHistoryEnabled);
                PTRReeferFound = true;
                return;
            }
        });
        if (!PTRReeferFound) {
            PopupWindow.showErrorMessage("Alert", "Selected Reefer is not found in Reefer Grid.");
        }
    }


    static SelectCurrentNode(currentReeferId: string) {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachLeafNode(function (node) {
            if (node.data != null && node.data != "undefined") {
                if (node.data.ReeferID === currentReeferId) {
                    node.setSelected(true);
                }
            }
        });
    }

    static ApplyReeferSearchFilter(filters: server.ReeferSearchFilters) {
        if (self != undefined) {
            //self.componentDidMount(); 
            self.setState({
                showServerSideGrid: JSON.parse(sessionStorage.getItem('SSRM')) == true ? true : false
            }, () => {
                $('#globalLoader').show();
                //        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined) {
                //            if (self.state.showServerSideGrid) {
                //                if (typeof self.state.gridApiParams.paginationGoToFirstPage() != "undefined") {
                //                    //self.state.gridApiParams.showLoadingOverlay();
                //                    self.state.gridApiParams.paginationGoToFirstPage();
                //                    self.state.gridApiParams.deselectAll();
                //                }
                //            }
                //}

                if (filters != null && filters != undefined) {
                    var customAttributesInfo = {};
                    var filterset: server.ReeferSearchFilters = {
                        SelectedOem: null, SelectedCountry: null, SelectedGeofence: null, SelectedGeofenceInside: null, SelectedInterval: null, SelectedReefer: null, SelectedAssetStates: null,
                        SelectedVesselCode: null, StatusFilters: [], AllReefers: null, CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: null, SelectedBookingNumber: null, SelectedVesselCD: null, SelectedVoyage: null, SelectedCall: null //WI-26881
                        , SelectedCargoCareProfiles: '', SelectedPol: '', SelectedPod: '', SelectedCTProfileIds: [] //RCNG5906-Added Profile Filter
                    };

                    filterset.SelectedCountry = (filters.SelectedCountry == "" || filters.SelectedCountry == undefined) ? null : filters.SelectedCountry;
                    filterset.SelectedGeofence = (filters.SelectedGeofence == "" || filters.SelectedGeofence == undefined) ? null : filters.SelectedGeofence;
                    filterset.SelectedGeofenceInside = (filters.SelectedGeofenceInside == "" || filters.SelectedGeofenceInside == undefined) ? null : filters.SelectedGeofenceInside;
                    filterset.SelectedInterval = (filters.SelectedInterval == "" || filters.SelectedInterval == undefined) ? null : filters.SelectedInterval;
                    filterset.SelectedAssetTypes = (filters.SelectedAssetTypes == "" || filters.SelectedAssetTypes == undefined) ? null : filters.SelectedAssetTypes;
                    filterset.SelectedAssetStates = (filters.SelectedAssetStates == "" || filters.SelectedAssetStates == undefined) ? null : filters.SelectedAssetStates;
                    filterset.SelectedOem = (filters.SelectedOem == "" || filters.SelectedOem == undefined) ? null : filters.SelectedOem;
                    filterset.SelectedReefer = (filters.SelectedReefer == "" || filters.SelectedReefer == undefined) ? null : filters.SelectedReefer;
                    filterset.SelectedBookingNumber = (filters.SelectedBookingNumber == "" || filters.SelectedBookingNumber == undefined) ? null : filters.SelectedBookingNumber;
                    filterset.AllReefers = (filters.AllReefers == "" || filters.AllReefers == undefined) ? null : filters.AllReefers;
                    filterset.SelectedVesselCode = (filters.SelectedVesselCode == "" || filters.SelectedVesselCode == undefined) ? null : filters.SelectedVesselCode;
                    filterset.SelectedCall = (filters.SelectedCall == "" || filters.SelectedCall == undefined) ? null : filters.SelectedCall; //WI-26881
                    filterset.SelectedVesselCD = (filters.SelectedVesselCD == "" || filters.SelectedVesselCD == undefined) ? null : filters.SelectedVesselCD; //WI-26881
                    filterset.SelectedVoyage = (filters.SelectedVoyage == "" || filters.SelectedVoyage == undefined) ? null : filters.SelectedVoyage; //WI-26881
                    filterset.StatusFilters = filters.StatusFilters;
                    filterset.CustomAttributeFilters = filters.CustomAttributeFilters;
                    filterset.SelectedCargoCareProfiles = (filters.SelectedCargoCareProfiles == "" || filters.SelectedCargoCareProfiles == undefined) ? null : filters.SelectedCargoCareProfiles;
                    filterset.SelectedPol = (filters.SelectedPol == "" || filters.SelectedPol == undefined) ? null : filters.SelectedPol; 
                    filterset.SelectedPod = (filters.SelectedPod == "" || filters.SelectedPod == undefined) ? null : filters.SelectedPod; 
                    filterset.SelectedCTProfileIds = (filters.SelectedCTProfileIds == null || filters.SelectedCTProfileIds == undefined) ? null : filters.SelectedCTProfileIds; //RCNG5906-Added Profile Filter

                    self.setState({
                        tempFilters: filterset
                    });
                    if (self.state.showServerSideGrid) {
                        var finalData = [];
                        self.setState({ rowData: [], PrevStartRow: -1, PrevEndRow: -1 });
                        var datasource = self.ServerSideDatasource(finalData);
                        self.state.gridApiParams.setServerSideDatasource(datasource);
                    }
                    else {
                        var resultSet = self.props.requestReeferAdvanceSearch(filterset);
                    }
                    //
                    //var finalData = [];
                    //var datasource = self.ServerSideDatasource(finalData);
                    //self.state.gridApiParams.setServerSideDatasource(datasource);
                    //params.api.setServerSideDatasource(datasource);
                }
            });
        }
    }

    static refreshGridReady(dashboardWidgetsSearch: any){
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 4);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "ReeferStatusGrid");
        }, 3000);       
    }
    
    onGridReadyServer(params: any) {
        var totalWidgetSearch = self.props.totalWidgetSearch;//WI26412
        $('#globalLoader').show();
        //this.gridApi.sizeColumnsToFit();
        self.setState({ gridApiParams: params.api });

        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 4);
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        $('#globalLoader').hide();
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, params.api, gridPreferencesData, "ReeferStatusGrid");
        }, 3000);
        //GridPreferenceControl.StatusGridPreferenceColumns(functionId, params.api, "ReeferStatusGrid");
        var finalData = [];
        var filterDefault: server.ReeferSearchFilters = {
            SelectedCountry: "", SelectedAssetTypes: "", SelectedAssetStates: "", SelectedGeofence: "", SelectedGeofenceInside: "", SelectedInterval: "", SelectedOem: "", SelectedReefer: "", SelectedVesselCode: "",
            StatusFilters: [12], CustomAttributeFilters: {}, AllReefers: "", SelectedBookingNumber: null, SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', //WI-26881
            SelectedCTProfileIds: [] //RCNG5906-Added Profile Filter
        };
        var filterDefault2: server.ReeferSearchFilters = {
            SelectedCountry: "", SelectedAssetTypes: "", SelectedAssetStates: "", SelectedGeofence: "", SelectedGeofenceInside: "", SelectedInterval: "", SelectedOem: "", SelectedReefer: "", SelectedVesselCode: "",
            StatusFilters: [12], CustomAttributeFilters: {}, AllReefers: null, SelectedBookingNumber: null, SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '', SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', //WI-26881
            SelectedCTProfileIds: [] //RCNG5906-Added Profile Filter
        };
        //if condition added for WI26412
        if (totalWidgetSearch) {
            var hasReeferFilter = self.props.statusFilter.SelectedAssetTypes;
            if (hasReeferFilter != null && hasReeferFilter != undefined && hasReeferFilter.length > 0) {
                var regexp = /Reefer/gi;
                if (hasReeferFilter.search(regexp) == -1) {
                    // console.log("Does not contain Reefer");
                } else {
                    if (self.props.hasReefer) {
                        let isEquals = isEqual(filterDefault, self.props.statusFilter);
                        if (!isEquals) {
                            var datasource = self.ServerSideDatasource(finalData);
                            params.api.setServerSideDatasource(datasource);
                        }
                    }
                }
            } else {
                let isEquals = isEqual(filterDefault2, self.props.statusFilter);
                if (!isEquals) {
                    var datasource = self.ServerSideDatasource(finalData);
                    params.api.setServerSideDatasource(datasource);
                }

            }
        }
        /* WI 26568 changes start */
        else {
            if (self.props.propsReeferData != null && self.props.propsReeferData != undefined && self.props.propsReeferData.length > 0) {
                var datasource = self.ServerSideDatasource(finalData);
                params.api.setServerSideDatasource(datasource);
            }
        }
        /* WI 26568 changes end */
    }

    showGridPreferenceColumns() {
        var gridApi = self.state.gridApiParams;
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 4);
        var defaultColumns = gridApi.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        gridApi.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        $('#globalLoader').hide();
        GridColumnPreferences.StatusGridPreferenceColumns(functionId, gridApi, gridPreferencesData, "ReeferStatusGrid");
    }

    static ClearSelection() {
        $('#globalLoader').show();
        //ReeferHistoryGrid.ClearHistoryGridData();
        //this.props.clearGridHeaderExtension();
        if (self != undefined) {
            self.state.gridApiParams.deselectAll();
        }
        //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'status', this.state.reeferFormatter.AlarmMasterList);


        $('#globalLoader').hide();

    }

    onGridPaginationChanged(params: any) {
        if (params.newPage) {
            self.props.clearGridHeaderExtension();
            if (!commandIssued)
                params.api.deselectAll();
            commandIssued = false;
            ReeferHistoryGrid.ClearHistoryGridData();
            //ReeferCallout.BindClusterMapPushpins(this.state.rowData, 'status');
        }
        if (params.api.getDisplayedRowCount() == 1 && (self.props.hasReefer && !self.props.hasGenset && !self.props.hasDry && !self.props.hasChassis)) {
            var rowindex = 0;
            var rowNode = params.api.getRowNode(rowindex);
            // do something with the row, eg select it
            if (rowNode != undefined && rowNode != null) {
                rowNode.setSelected(true);
                ReeferHistoryGrid.ApplyReeferHistorySearch(rowNode.data, false, self.props.reeferHistoryEnabled);
            }
        }
    }

    italicizeGridRows(params: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.EventDTTM != params.data.UnitEventDTTM)
                return { 'font-style': 'italic' }
        }
    }

    onGridSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows.length != 0) {
            var selected = params.api.getFocusedCell();
            if (selected != null) {
                var selectedRow = params.api.getRowNode(selected.rowIndex);
                ReeferCallout.ResetMapPushpins(); // Clear existing pushpins
                selectedRows.forEach(function (selectedRow, index) {
                    selectedReeferData.push(selectedRow);
                });
            }

            //var selectedItems = self.state.selectedItems;
            self.setState({
                selectedItems: selectedReeferData,
                isChangeDeforstInterval: false,
                pretripCmd: null,
                modelTitle: '',
                popUpHtml: '',
                modelTitleReport: '',
                popUpHtmlReport: ''
            });

            self.props.getSelectedRow(selectedRows);
        }
    }

    ValidateBookingID(reeferData: any) {
        if (reeferData.length > 0 && reeferData[0].LastBookingEventMasterId != null && reeferData[0].LastBookingEventMasterId.length > 0) {
            for (var lastBookingID in reeferData[0].LastBookingEventMasterId) {
                if (reeferData[0].EventMasterID == parseInt(reeferData[0].LastBookingEventMasterId[lastBookingID])) {
                    return true;
                }
            }
        }
        return false;
    }

    static ReeferStatusResult() {
        ReeferStatusSSRMGrid.ApplyReeferSearchFilter(self.state.tempFilters);
    }
    HideAllContextMenus() {
        $("#gensetcontextmenu").hide();
        $(".gensetcontext-menu").hide();
        $("#drycontextmenu").hide();
        $(".drycontext-menu").hide();
        $("#chassiscontextmenu").hide();
        $(".chassiscontext-menu").hide();
        $("#contextmenu").hide();
        $(".context-menu").hide();
    }

    copyRowsToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }
    
    ServerSideDatasource(data) {
        return {
            getRows: (params) => {
                //var sprops = self.props.statusFilter;
                //var newfilters: server.ReeferSearchFiltersPaginated = {
                //    SelectedOem: self.props.statusFilter.SelectedOem,
                //    SelectedCountry: self.props.statusFilter.SelectedCountry,
                //    SelectedGeofence: self.props.statusFilter.SelectedGeofence,
                //    SelectedGeofenceInside: self.props.statusFilter.SelectedGeofenceInside,
                //    SelectedInterval: self.props.statusFilter.SelectedInterval,
                //    SelectedReefer: self.props.statusFilter.SelectedReefer,
                //    SelectedVesselCode: self.props.statusFilter.SelectedVesselCode,
                //    StatusFilters: self.props.statusFilter.StatusFilters,
                //    AllReefers: self.props.statusFilter.AllReefers,
                //    CustomAttributeFilters: self.props.statusFilter.CustomAttributeFilters,
                //    SelectedAssetTypes: self.props.statusFilter.SelectedAssetTypes,
                //    SelectedBookingNumber: self.props.statusFilter.SelectedBookingNumber,
                //    StartRow: params.request.startRow,
                //    EndRow: params.request.endRow
                //};
                //changed below code to get data from self.state.tempFilters for WI26449
                var newfilters: server.ReeferSearchFiltersSSRM = {
                    SelectedOem: self.state.tempFilters.SelectedOem,
                    SelectedCountry: self.state.tempFilters.SelectedCountry,
                    SelectedGeofence: self.state.tempFilters.SelectedGeofence,
                    SelectedGeofenceInside: self.state.tempFilters.SelectedGeofenceInside,
                    SelectedInterval: self.state.tempFilters.SelectedInterval,
                    SelectedReefer: self.state.tempFilters.SelectedReefer,
                    SelectedVesselCode: self.state.tempFilters.SelectedVesselCode,
                    StatusFilters: self.state.tempFilters.StatusFilters,
                    AllReefers: self.state.tempFilters.AllReefers,
                    CustomAttributeFilters: self.state.tempFilters.CustomAttributeFilters,
                    SelectedAssetTypes: self.state.tempFilters.SelectedAssetTypes,
                    SelectedAssetStates: self.state.tempFilters.SelectedAssetStates,
                    SelectedBookingNumber: self.state.tempFilters.SelectedBookingNumber,
                    StartRow: params.request.startRow,
                    EndRow: params.request.endRow,
                    RowGroupCols: params.request.rowGroupCols,
                    GroupKeys: params.request.groupKeys,
                    SortModels: params.request.sortModel,
                    SelectedVesselCD: self.state.tempFilters.SelectedVesselCD,
                    SelectedVoyage: self.state.tempFilters.SelectedVoyage,
                    SelectedCall: self.state.tempFilters.SelectedCall,
                    SelectedCargoCareProfiles: self.state.tempFilters.SelectedCargoCareProfiles,
                    SelectedPol: self.state.tempFilters.SelectedPol,
                    SelectedPod: self.state.tempFilters.SelectedPod,
                    SelectedCTProfileIds: self.state.tempFilters.SelectedCTProfileIds //RCNG5906-Added Profile Filter
                };
                //var p = new ReeferSearchFilters()
                // sprops.          
                //var resultSet = await self.props.requestReeferAdvanceSearch(newfilters);
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCurrentConditionReeferDataSP', { method: 'POST', body: JSON.stringify(newfilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
                let fetchTask = fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<any[]>)
                    .then(finalData => {
                        var response = this.getData_old(finalData, params.request);
                        if (!response.rows.length) {
                            self.state.gridApiParams.showNoRowsOverlay();
                        }
                        else {
                            self.state.gridApiParams.hideOverlay();
                        }
                        setTimeout(function () {
                            if (response.success) {
                                $('#globalLoader').hide();
                                params.successCallback(response.rows, response.lastRow);
                            } else {
                                params.failCallback();
                            }
                        }, 200);
                    });

            },
        };
    };

    ServerSideDatasource_old(data) {
        return {
            getRows: (params) => {
                var sprops = self.props.statusFilter;
                var newfilters: server.ReeferSearchFiltersSSRM = {
                    SelectedOem: self.props.statusFilter.SelectedOem,
                    SelectedCountry: self.props.statusFilter.SelectedCountry,
                    SelectedGeofence: self.props.statusFilter.SelectedGeofence,
                    SelectedGeofenceInside: self.props.statusFilter.SelectedGeofenceInside,
                    SelectedInterval: self.props.statusFilter.SelectedInterval,
                    SelectedReefer: self.props.statusFilter.SelectedReefer,
                    SelectedVesselCode: self.props.statusFilter.SelectedVesselCode,
                    StatusFilters: self.props.statusFilter.StatusFilters,
                    AllReefers: self.props.statusFilter.AllReefers,
                    CustomAttributeFilters: self.props.statusFilter.CustomAttributeFilters,
                    SelectedAssetTypes: self.props.statusFilter.SelectedAssetTypes,
                    SelectedAssetStates: self.props.statusFilter.SelectedAssetStates,
                    SelectedBookingNumber: self.props.statusFilter.SelectedBookingNumber,
                    StartRow: params.request.startRow,
                    EndRow: params.request.endRow,
                    RowGroupCols: null,
                    GroupKeys: null,
                    SortModels: null,
                    SelectedVesselCD: self.state.tempFilters.SelectedVesselCD,
                    SelectedVoyage: self.state.tempFilters.SelectedVoyage,
                    SelectedCall: self.state.tempFilters.SelectedCall,
                    SelectedCargoCareProfiles: self.state.tempFilters.SelectedCargoCareProfiles,
                    SelectedPol: self.state.tempFilters.SelectedPol,
                    SelectedPod: self.state.tempFilters.SelectedPod,
                    SelectedCTProfileIds: self.state.tempFilters.SelectedCTProfileIds //RCNG5906-Added Profile Filter
                };
                //var p = new ReeferSearchFilters()
                // sprops.
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCurrentConditionReeferDataSP', { method: 'POST', body: JSON.stringify(newfilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
                let fetchTask = fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<any[]>)
                    .then(finalData => {
                        var response = this.getData_old(finalData, params.request);
                        if (!response.rows.length) {
                            self.state.gridApiParams.showNoRowsOverlay();
                        }
                        else {
                            self.state.gridApiParams.hideOverlay();
                        }
                        setTimeout(function () {
                            if (response.success) {
                                $('#globalLoader').hide();
                                params.successCallback(response.rows, response.lastRow);
                            } else {
                                params.failCallback();
                            }
                        }, 200);
                    });

            },
        };
    };
    sortAndFilter(allOfTheData, sortModel, filterModel) {
        return this.sortData(sortModel, this.filterData(filterModel, allOfTheData));
    }
    sortData(sortModel, data) {
        var sortPresent = sortModel && sortModel.length > 0;
        if (!sortPresent) {
            return data;
        }
    }
    filterData(filterModel, data) {
        var filterPresent = filterModel && Object.keys(filterModel).length > 0;
        if (!filterPresent) {
            return data;
        }
        data = data.filter(i => {
            if (Object.keys(i).some(k => i[k] && i[k].toString().toLowerCase().includes(filterModel['-'].filter)))
                return i;
        })
        return data;
    }
    getData_old(params, req) {
        var newData = params;//params.slice(req.startRow, req.endRow);
        //var dataAfterSortingAndFiltering = this.sortAndFilter(newData, params.sortModel, params.filterModel);
        //let reefersData = params; //Object.assign({}, params);
        let reefersData = cloneDeep(params);
        //let reefersData = Object.assign({}, params);
        var reeferStateData = self.state.rowData;
        //if (req.endRow != reeferStateData.length && req.endRow > reeferStateData.length && params.length != reeferStateData.length) {
        if (req.endRow != reeferStateData.length && req.endRow > reeferStateData.length && req.endRow != this.state.PrevEndRow) {
            reefersData.push(...reeferStateData);
            self.setState({ rowData: reefersData, PrevEndRow: req.endRow, PrevStartRow: req.startRow }, () => {
                //ReeferCallout.ResetMapPushpins();
                ReeferCallout.BindClusterMapPushpins(self.state.rowData, 'status', this.state.reeferFormatter);
            });
        }
        else {
            ReeferCallout.BindClusterMapPushpins(self.state.rowData, 'status', this.state.reeferFormatter);
        }


        //var sortedData = [];
        //var sortColId = '';
        //var sort = ''; //asc or desc
        //if (req.sortModel.length) {
        //    // implement fake sorting
        //    req.sortModel.forEach(element => {
        //        sortColId = element.colId;
        //        sort = element.sort;
        //    });

        //    if (sort == 'asc') {
        //        sortedData = lodashsortBy(newData, sortColId);
        //    } else {
        //        sortedData = lodashsortBy(newData, sortColId).reverse();
        //    }
        //    newData = sortedData;
        //}
        return {
            success: true,
            rows: newData,
            lastRow: this.getLastRowIndex(req, newData),//params.length,//getLastRowIndex(req, newData),
        };
    };

    getLastRowIndex(request, results) {
        if (!results || results.length === 0) {
            return request.startRow;
        }
        if (self.state.rowData.length == request.endRow || (parseInt(self.state.rowData.length) % parseInt(self.state.pageSize) == 0)) {
            var currentLastRow = request.startRow + results.length+1;
        } else {
            var currentLastRow = request.startRow + results.length;
        }

        return currentLastRow <= request.endRow ? currentLastRow : -1;
    }
    getReeferContextMenuItems = params => {
        //TODO : after test uncommnet below line
        //RCUtils.HighlightCurrentGridRow(params,"ReeferID",self.state.selectedItems);
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var reeferid = selectedrowNode.data.ReeferID;
                params.api.forEachNode((newRowNode, index) => {
                    if ((newRowNode.data.ReeferID === reeferid)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.ReeferID == selectedrowNode.data.ReeferID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var selectedReeferData = [];
            var selectedRows = params.api.getSelectedRows();
            selectedRows.forEach(function (selectedRow, index) {
                selectedReeferData.push(selectedRow);
            });
            var distinctOEM = [];
            var fullPreTripLabel = 'Full';
            var shortPreTripLabel = 'Short';
            var funcPreTripLabel = 'Function Test';
            $.each(selectedReeferData, function (i, val) {
                if (val.ReeferOEMTypeCd != null && val.ReeferOEMTypeCd != undefined) {
                    if ($.inArray(val.ReeferOEMTypeCd, distinctOEM) === -1) {
                        distinctOEM.push(val.ReeferOEMTypeCd);
                    }
                }
            });
            if (distinctOEM.length == 1) {
                if (self.state.reeferFormatter != null || self.state.reeferFormatter != undefined) {
                    var customerSpecificCommandList = self.state.reeferFormatter.CustomerSpecificCommandList;
                    var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                    if (customerSpecificCommandList != null && customerSpecificCommandList.length > 0) {
                        var custSpecificCommandList = lodashfilter(customerSpecificCommandList, function (item) {
                            return item.CustomerId === custId;
                        });
                        if (custSpecificCommandList != null && custSpecificCommandList.length > 0) {
                            var fullCustSpecificCommandList = lodashfilter(custSpecificCommandList, function (item) {
                                return item.OemTypeCD === distinctOEM[0].toString()
                                    && item.Tag === "StartFullPTI";
                            });
                            if (fullCustSpecificCommandList != null && fullCustSpecificCommandList.length > 0) {
                                fullPreTripLabel = fullCustSpecificCommandList[0].Text;
                            }
                            else if (distinctOEM[0].toString().trim() == 'C') {
                                fullPreTripLabel = 'Auto 2';
                            }
                            var shortCustSpecificCommandList = lodashfilter(custSpecificCommandList, function (item) {
                                return item.OemTypeCD === distinctOEM[0].toString()
                                    && item.Tag === "StartShortPTI";
                            });
                            if (shortCustSpecificCommandList != null && shortCustSpecificCommandList.length > 0) {
                                shortPreTripLabel = shortCustSpecificCommandList[0].Text;
                            }
                            else if (distinctOEM[0].toString().trim() == 'C') {
                                shortPreTripLabel = 'Auto 3';
                            }
                            var funcCustSpecificCommandList = lodashfilter(custSpecificCommandList, function (item) {
                                return item.OemTypeCD === distinctOEM[0].toString()
                                    && item.Tag === "StartCAShortPTI";
                            });
                            if (funcCustSpecificCommandList != null && funcCustSpecificCommandList.length > 0) {
                                funcPreTripLabel = funcCustSpecificCommandList[0].Text;
                            }
                            else if (distinctOEM[0].toString().trim() == 'C') {
                                funcPreTripLabel = 'Auto 1';
                            }
                        }
                        else if (distinctOEM[0].toString().trim() == 'C') {
                            fullPreTripLabel = 'Auto 2';
                            shortPreTripLabel = 'Auto 3';
                            funcPreTripLabel = 'Auto 1';
                        }
                    }
                    else if (distinctOEM[0].toString().trim() == 'C') {
                        fullPreTripLabel = 'Auto 2';
                        shortPreTripLabel = 'Auto 3';
                        funcPreTripLabel = 'Auto 1';
                    }
                }
            }
            self.setState({
                fullPreTripCommandText: fullPreTripLabel,
                shortPreTripCommandText: shortPreTripLabel,
                funcPreTripCommandText: funcPreTripLabel
            });
            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
                //'copy',
                //'copyWithHeaders',
                {
                    name: 'Map',
                    action: () => {
                        this.reeferContextMenuClick("Map");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('14'),
                },
                {
                    name: 'Current Details',
                    action: () => {
                        this.reeferContextMenuClick("Details");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('154'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'CurrentDetails'),
                },
                {
                    name: 'History',
                    action: () => {
                        this.reeferContextMenuClick("History");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('15'),
                },
                {
                    name: 'Command History',
                    action: () => {
                        this.reeferContextMenuClick("CommandStatus");
                    },
                    cssClasses: UserRights.checkMenuItemVisibility('155'),
                },
                {
                    name: 'CargoCare',
                    cssClasses: UserRights.checkCommandMenuItemVisibilityMultiple('76, 77, 224', params),
                    subMenu: [
                        {
                            name: 'Assign to CargoCare',
                            subMenu: this.assignToCargoCareSubMenu(selectedReeferData[0].CCProfileCode, params),
                            //action: () => {
                            //    this.assignCargoCare();
                            //},
                            cssClasses: UserRights.checkMenuItemVisibility('76'),
                            //disabled: UserRights.checkMenuItemDisabled(params, 'AssigntoCargoCare'),
                        },
                        {
                            name: 'Unassign from CargoCare',
                            action: () => {
                                this.unAssignCaregoCare();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('77'),
                            disabled: UserRights.checkMenuItemDisabled(params, 'UnassignfromCargoCare'),
                        },
                        {
                            name: 'Clear CargoCare Alerts',
                            subMenu: this.ClearCargoCareAlertsSubMenu(selectedReeferData),

                            cssClasses: UserRights.checkMenuItemVisibility('224'),//RCNG-588
                            disabled: UserRights.checkClearCargoCareAlertsSubMenuItemDisabled(params, 'ClearCargoCareAlerts'),
                        },
                        /*{
                            name: 'Clear Set Point',
                            action: () => {
                                this.clearSetPoint();
                            },
                            //disabled: UserRights.checkMenuItemClearSetPointDisabled(params),
                            disabled: UserRights.checkMenuItemDisabled(params, 'ClearSetPoint'),
                        },*/
                    ],
                },
                {
                    name: 'Commands',
                    cssClasses: UserRights.checkCommandMenuItemVisibilityMultiple('18, 19, 20, 21, 22, 23, 26, 27, 24, 25, 28, 29, 30, 31, 32, 33, 80, 81, 83, 84, 85, 89, 90, 92, 103, 104, 106, 108, 109, 111, 112, 113, 114, 115, 116, 118, 122, 123, 125, 126, 145, 150', params),
                    disabled:
                        //EnableLynxCommands ? UserRights.checkMenuItemDisabledForCommands(params, 'Commands'):
                        UserRights.checkMenuItemDisabledForLynxCommands(params, 'Commands', EnableLynxCommands, EnableCT35ML5Commands, self.state.reeferFormatter.RefControllerTypes),//RCNG-1842,RCNG-3425
                    subMenu: [
                        {
                            name: 'Reporting',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('26, 81, 145, 150', params, 'Reporting', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Ping / Report',
                                    action: () => {
                                        this.popUpPing();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('26', params, 'Ping', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Set Reporting Interval',
                                    action: () => {
                                        this.popUpChangeReporting();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('81', params, 'SetReportingInterval', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'SetReportingInterval'),
                                },
                                {
                                    name: 'Device Reset',
                                    action: () => {
                                        this.popUpDeviceReset();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('145', params, 'DeviceReset', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Device Reset To Defaults',
                                    action: () => {
                                        this.popUpDeviceHardReset();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('150', params, 'DeviceResetToDefaults', self.state.reeferFormatter.RefControllerTypes),
                                },
                            ],
                        },
                        {

                            name: 'Reefer Settings',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('23, 27, 24, 25, 28, 92, 108,267,268,269', params, 'ReeferSettings', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Change Setpoints',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('23, 27, 24, 25', params, 'ChangeSetpoints', self.state.reeferFormatter.RefControllerTypes),
                                    subMenu: [
                                        {
                                            name: 'Temperature',
                                            action: () => {
                                                this.popUpChangeTempSetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibility('23'),
                                        },
                                        {
                                            name: 'Humidity',
                                            action: () => {
                                                this.popUpHumiditySetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('27', params, 'Humidity', self.state.reeferFormatter.RefControllerTypes),
                                            disabled: UserRights.checkMenuItemDisabled(params, 'Humidity'),
                                        },
                                        {
                                            name: 'O2',
                                            action: () => {
                                                this.popUpO2SetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('24', params, 'O2', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CO2',
                                            action: () => {
                                                this.popUpCo2SetPoint();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('25', params, 'CO2', self.state.reeferFormatter.RefControllerTypes),
                                        },

                                    ],
                                },
                                {
                                    name: 'Clock',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('92, 108', params, 'Clock', self.state.reeferFormatter.RefControllerTypes),
                                    subMenu: [
                                        {
                                            name: 'Sync to Device',
                                            action: () => {
                                                this.popUpSyncReeferClock();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('92', params, 'SynctoDevice', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Clock Sync Settings',
                                            action: () => {
                                                this.popUpChangeReeferClockSyncSetting();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('108', params, 'ClockSyncSettings', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                    ],
                                },
                                {
                                    name: 'Change Reefer ID',
                                    action: () => {
                                        this.popUpChangeReeferId();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('28', params, 'ChangeReeferID', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ChangeReeferID'),
                                },
                                {
                                    name: 'Controlled Atmosphere',
                                    action: () => {
                                        this.popUpControlledAtmosphere();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('139', params, 'ControlledAtmosphere', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Fan Speed',
                                    action: () => {
                                        this.popUpFanSpeed();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('269', params, 'FanSpeed', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabledforDimiSetting(params, 'FanSpeed'),
                                },
                                {
                                    name: 'OEM PTI',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('267,268', params, 'OEMPTI', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabledforDimiSetting(params, 'OEMPTI'),
                                    subMenu: [
                                        {
                                            name: 'DIMI Settings',
                                            action: () => {
                                                this.popUpDIMISettings();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('267', params, 'DIMISettings', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Intelligent PTI Function',
                                            action: () => {
                                                this.popUpIntelligentPTIFunction();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('268', params, 'IntelligentPTIFunction', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                    ],
                                }
                            ],
                        },
                        {
                            name: 'Reefer Data Log',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByDataForTDD('29, 31, 32, 80', params, 'ReeferDataLog', self.state.reeferFormatter.RefControllerTypes, ShowTDDForCT36ML5, ShowTDDForCT35ML5),
                            disabled: UserRights.checkMenuItemDisabledForTDD(params, 'ReeferDataLog', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Get Data Log',
                                    action: () => {
                                        this.popUpDLTraditional(this);
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyDataForTDD('31', params, 'GetDataLog', self.state.reeferFormatter.RefControllerTypes, ShowTDDForCT36ML5, ShowTDDForCT35ML5),
                                },
                                {
                                    name: 'Set Data Log Interval',
                                    action: () => {
                                        this.popUpChangeDatalog();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('29', params, 'SetDataLogInterval', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Real-Time Retrieval Settings',
                                    //action: () => {
                                    // to do Check 
                                    //this.popUpChangeDatalog();
                                    //},
                                    cssClasses: UserRights.checkMenuItemVisibility('32, 80'),
                                },
                            ],
                        },
                        {
                            name: 'Reefer Pre-Trip',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('18, 19, 20, 21, 30, 106, 206', params, 'ReeferPreTrip', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Start Pre-Trip',
                                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('18, 19, 20'),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'StartPre-Trip'),
                                    subMenu: [
                                        {
                                            name: this.state.fullPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpPreTripFull();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('18', params, 'fullPreTripCommandText', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: this.state.shortPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpPreTripShort();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('19', params, 'shortPreTripCommandText', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: this.state.funcPreTripCommandText.toString(),
                                            action: () => {
                                                this.popUpFunctionTest();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('20', params, 'funcPreTripCommandText', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Chilled',
                                            action: () => {
                                                this.popUpChangeToChilled();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('140', params, 'Chilled', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Frozen',
                                            action: () => {
                                                this.popUpChangeToFrozen();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('141', params, 'Frozen', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA',
                                            action: () => {
                                                this.popUpChangeToCA();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('142', params, 'CA', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA Full',
                                            action: () => {
                                                this.popUpChangeToCAFullPTI();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('143', params, 'CAFull', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'CA Function Test',
                                            action: () => {
                                                this.popUpChangeToCAFunctionTest();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('144', params, 'CAFunctionTest', self.state.reeferFormatter.RefControllerTypes),
                                        },
                                        {
                                            name: 'Chilled and CA',
                                            action: () => {
                                                this.popUpChangeToChilledandCA();
                                            },
                                            cssClasses: UserRights.checkMenuItemVisibilitybyData('148', params, 'ChilledandCA', self.state.reeferFormatter.RefControllerTypes),
                                        },

                                    ],
                                },
                                {
                                    name: 'Stop Pre-Trip',
                                    action: () => {
                                        this.popUpStopPTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('21', params, 'StopPre-Trip', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'StopPre-Trip'),
                                },
                                {
                                    name: 'Scheduled Pre-Trip',
                                    action: () => {
                                        this.popUpSchedulePTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('106', params, 'ScheduledPre-Trip', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Get Pre-Trip Results',
                                    action: () => {
                                        this.popUpGetPTI();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('30', params, 'GetPre-TripResults', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Show Pre-Trip Results',
                                    action: () => {
                                        this.popUpGetPTIReport();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('30', params, 'ShowPre-TripResults', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ShowPreTripResults'),
                                },
                                ,
                                {
                                    name: 'Get TripWISE Report',
                                    action: () => {
                                        this.popUpGetTWR();
                                    },
                                    cssClasses: UserRights.checkTripWISEVisibilitybyData('206', params, 'GetTripWISEReport', tripWISESupport),
                                },
                                {
                                    name: 'Show TripWISE Report',
                                    action: () => {
                                        this.popUpGetTWReport();
                                    },
                                    cssClasses: UserRights.checkTripWISEVisibilitybyData('261', params, 'ShowTripWISEReport', tripWISESupport),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'ShowTripWISEReport'),
                                },
                            ],
                        },
                        {
                            name: 'Reboot Reefer Controller',
                            action: () => {
                                this.popUpRebootReefer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('22', params, 'RebootReeferController', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Query Reefer Inventory',
                            action: () => {
                                this.popUpQueryReefer();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('83,84,85', params, 'QueryReeferInventory', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Reefer Model Configuration',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('89, 90', params, 'ReeferModelConfiguration', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [
                                {
                                    name: 'Update',
                                    action: () => {
                                        this.popUpUpdateModelConfig();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('89', params, 'Update', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Verify',
                                    action: () => {
                                        this.popUpVerifyModelValidity();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('90', params, 'Verify', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabled(params, 'Verify'),
                                },
                            ],

                        },
                        {
                            name: 'Defrost',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('103, 104', params, 'Defrost', self.state.reeferFormatter.RefControllerTypes),
                            disabled: UserRights.checkMenuItemDisabled(params, 'Defrost'),

                            subMenu: [

                                {
                                    name: 'Start Defrost',
                                    action: () => {
                                        this.popUpStartDeforst();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('103', params, 'StartDefrost', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Change Defrost Interval',
                                    action: () => {
                                        this.popUpChangeDeforstInterval();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('104', params, 'ChgDefrostInterval', self.state.reeferFormatter.RefControllerTypes),
                                    disabled: UserRights.checkMenuItemDisabledForDefrost(params, 'ChgDefrostInterval', self.state.reeferFormatter.RefControllerTypes),
                                },

                            ],
                        },
                        {

                            name: 'Multiple Setpoints',
                            action: () => {
                                this.popUpMSC();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('123', params, 'MultipleSetpoints', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Automatic Cold Treatment',
                            action: () => {
                                this.popUpACT();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('122', params, 'AutomaticColdTreatment', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Guest Reefer configuration',
                            action: () => {
                                this.popUpGuestReeferConfigCmd();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('112, 113, 114, 115, 116', params, 'GuestReeferconfiguration', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Change Zigbee Config Settings',
                            action: () => {
                                this.popUpZigbeeSettings();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('118', params, 'ChangeZigbeeConfigSettings', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Assign PAN Id',
                            action: () => {
                                this.popUpAssignPanId();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('109', params, 'AssignPANId', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Device Configuration',
                            action: () => {
                                this.popAutoConfiguration();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('110', params, 'DeviceConfiguration', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Asset Configuration',
                            action: () => {
                                this.popAssetConfiguration();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('121', params, 'AssetConfiguration', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Fresh Air Type',
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleByData('125, 126', params, 'FreshAirType', self.state.reeferFormatter.RefControllerTypes),
                            subMenu: [

                                {
                                    name: 'Get - Fresh Air Type',
                                    action: () => {
                                        this.popUpGetFreshAirType();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('125', params, 'Get-FreshAirType', self.state.reeferFormatter.RefControllerTypes),
                                },
                                {
                                    name: 'Set - Fresh Air Type',
                                    action: () => {
                                        this.popUpSetFreshAirType();
                                    },
                                    cssClasses: UserRights.checkMenuItemVisibilitybyData('126', params, 'Set-FreshAirType', self.state.reeferFormatter.RefControllerTypes),
                                },

                            ],
                        },
                        {
                            name: 'Get Asset ID',
                            action: () => {
                                this.popUpGetAssetId();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('199', params, 'GetAssetId', self.state.reeferFormatter.RefControllerTypes),
                        },
                        {
                            name: 'Enable Door Sensor',
                            action: () => {
                                this.popUpEnableDoorSensor();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilitybyData('207', params, 'EnableDoorSensor', self.state.reeferFormatter.RefControllerTypes),
                        },
                    ],
                },
                {
                    name: 'Trip',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('94, 95, 98'),
                    subMenu: [
                        {
                            name: 'Create Trip',
                            action: () => {
                                this.popUpCreateTrip();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('95'),
                        },
                        {
                            name: 'Trip Status',
                            action: () => {
                                this.popUpTripStatus();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('94'),
                        },
                        {
                            name: 'Clear Deviation',
                            action: () => {
                                this.popUpClearDeviation();
                            },
                            cssClasses: UserRights.checkMenuItemVisibility('98'),
                            disabled: UserRights.checkMenuItemDisabled(params, 'ClearDeviation'),
                        },
                    ],
                },
                {
                    name: 'Booking and Access',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('40, 82, 100, 101, 102'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'BookingandAccess'),
                    subMenu: [
                        {
                            name: 'Assign / Edit',
                            action: () => {
                                this.popUpAssignBooking();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('40, 100, 102'),
                        },
                        {
                            name: 'Unassign',
                            action: () => {
                                this.popUpUnAssignBooking();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('82, 101'),
                            disabled: UserRights.checkMenuItemUnAssignDisabled(params, 'Unassign',self.state.reeferFormatter.EventMasterList),
                        },
                    ],
                },
                {
                    name: 'Bookings',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('212,211,213,214,249'),//Added Right id for RCNG-945
                    disabled: UserRights.checkMenuItemDisabled(params, 'NewBookingandAccess'),
                    subMenu: [
                        {
                            name: 'Create New Booking',
                            action: () => {
                                this.reeferContextMenuClick("CreateBooking");
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('211'),
                            disabled: UserRights.checkMenuItemUnAssignDisabled(params, 'NewBookingCreate', self.state.reeferFormatter.EventMasterList),
                        },
                        {
                            name: 'Edit Booking',
                            action: () => {
                                this.reeferContextMenuClick("EditBooking");
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('212'),
                            disabled: UserRights.checkMenuItemUnAssignDisabled(params, 'NewBookingEdit', self.state.reeferFormatter.EventMasterList),
                        },
                        {
                            name: 'View Booking',
                            action: () => {
                                //this.reeferContextMenuClick("ViewBooking");
                                this.popUpViewBooking();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('213'),
                            disabled: UserRights.checkMenuItemUnAssignDisabled(params, 'ViewBooking', self.state.reeferFormatter.EventMasterList),
                        },
                        {
                            name: 'Unassign Booking',
                            action: () => {
                                this.popUpNewUnAssignBooking();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('214'),
                            disabled: UserRights.checkMenuItemUnAssignDisabled(params, 'Unassign', self.state.reeferFormatter.EventMasterList),
                        },
                        {
                            name: 'Third-Party Access',
                            action: () => {
                                this.popUpAssignBooking();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultiple('249'),
                        },
                    ],
                },
                {
                    name: 'Edit Voyage',
                    action: () => {
                        this.popUpEditVoyage();
                    },
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('248'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'EditVoyage'),
                },
                {
                    name: 'Inventory',
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('208,209'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'RetireOrReactivate'),
                    subMenu: [
                        {
                            name: 'Retire',
                            action: () => {
                                this.popUpRetire();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('208', params, "Retire"),
                        },
                        {
                            name: 'Reactivate',
                            action: () => {
                                this.popUpReactivate();
                            },
                            cssClasses: UserRights.checkMenuItemVisibilityMultipleInventory('209', params, "Reactivate"),
                        },
                    ],
                },
                {
                    name: 'Confirm Controller Swap',
                    action: () => {
                        this.popUpControllerSwap();
                    },
                    cssClasses: UserRights.checkMenuItemVisibilityMultiple('47'),
                    disabled: UserRights.checkMenuItemDisabled(params, 'ConfirmControllerSwap'),
                },
                'separator',
                {
                    name: 'Export',
                    action: () => {
                        this.popUpExport();
                    },
                },
                {
                    name: 'Send Email',
                    action: () => {
                        this.popUpSendEmail();
                    },
                },
            ];
            return result;
        }
    };


    defaultColDef() {
        return [{
            flex: 1,
            minWidth: 100,
            filter: false,
            sortable: false,
            enableRowGroup: false,
            resizable: true,
        }]
    }

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators',
                children: [
                    {
                        headerName: "CC", field: "CCSeverityLevel", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return ReeferFormatters.CargoCareFormatterForFilter(params); } }, resizable: true, width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter,
                        tooltipComponent: 'cCAlmTooltip',tooltipValueGetter: this.toolTipValueGetter, cellRendererParams: { almData: self.state.reeferFormatter.AlarmMasterList },onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "ALM", field: "MASeverityLevel", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return ReeferFormatters.statusIndicatorWithDescriptionForALMForFilter(params) } }, valueGetter: (params) => { return ReeferFormatters.statusALMSorting(params); }, resizable: true, width: 65, cellRenderer: (params) => { return ReeferCellRenderer.StatusIndicatorWithDescriptionForAlarms(params, self.state.reeferFormatter.AlarmMasterList); }, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "RUN", field: "RunState", width: 75, enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return ReeferFormatters.runStateFormatterForFilter(params); } }, resizable: true, valueGetter: (params) => { return ReeferFormatters.RunstateSorting(params); }, cellRenderer: ReeferCellRenderer.RunStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "PWR", field: "DevicePowerSourceCd", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return Formatters.pwrStateFormatterForFilter(params); } }, resizable: true, width: 75, valueGetter: (params) => { return Formatters.PwrSorting(params); }, cellRenderer: ReeferCellRenderer.PwrStateFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BATT", field: "ReeferBatteryPct", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return Formatters.reeferBatteryPctFormatterFilter(params); } }, resizable: true, width: 65, valueGetter: (params) => { return Formatters.reeferBatteryPctSorting(params); }, cellRenderer: ReeferCellRenderer.BatteryPctFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "VSL", field: "VesselCd", enableRowGroup: false, cellClass: 'myExcelStyle', hide: true, sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "VVC Dep", field: "DepartingVVC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.DepartingVVCstringTypeValueFormatter(params); }, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "VVC Arr", field: "ArrivingVVC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.ArrivingVVCstringTypeValueFormatter(params); }, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "TRIP", field: "TripStatusCdAndDFlag", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, resizable: true, tooltipField: "TripNameAndStatus", width: 70, valueGetter: (params) => { return ReeferFormatters.TripSorting(params); }, cellRenderer: ReeferCellRenderer.TripstatusIndicator, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "INV", field: "AssetState", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: ReeferCellRenderer.AssetStateFormatter, columnGroupShow: 'open', onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: "Identification",
                children: [
                    {
                        headerName: "OEM", field: "ReeferOEMTypeCd", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false,
                        filterParams: { valueGetter: params => { return ReeferFormatters.oemTypeFormatterForFilter(params); } }, resizable: true,
                        valueGetter: params => { return ReeferFormatters.OEMTypeValueFormatterFieldName(params); },
                        width: 70, onCellClicked: this.onCellClickedCopy.bind(this)
                    },


                    { headerName: "Reefer ID", field: "ReeferID", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ReeferID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Model", field: "OEMModel", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.UnitTypesListFormatters(params, self.state.reeferFormatter.UnitTypesList); }, cellRenderer: (params) => { return ReeferFormatters.UnitTypesListFormatters(params, self.state.reeferFormatter.UnitTypesList); }, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: "Booking",
                children: [
                    { headerName: "Booking #", field: "BookingNumber", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BookingNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK temp ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "TemperatureUnit"); }, cellRenderer: ReeferFormatters.TemperatureFormatterForBooking, field: "TemperatureUnit", columnGroupShow: 'open', width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Assigned to", field: "CustomerName", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSortingFor3P(params.data.CustomerName); }, filterParams: { valueGetter: params => { return Formatters.stringTypeFormatterFor3PForFilter(params); } }, cellRenderer: ReeferCellRenderer.StringTypeFormatterFor3P, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), columnGroupShow: 'open' },
                    { headerName: "CC profile", field: "CCProfileCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CCProfileCode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "CC alerts", field: "CCAlarms", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return ReeferFormatters.CCAlarmAliasDescriptionSorting(params, self.state.reeferFormatter.AlarmMasterList); }, cellRenderer: (params) => { return ReeferCellRenderer.CCAlertAlarmAliasDescriptionFormatter(params, self.state.reeferFormatter.AlarmMasterList) }, tooltipComponent: 'cCAlmTooltip', tooltipValueGetter: this.toolTipValueGetter, cellRendererParams: { almData: self.state.reeferFormatter.AlarmMasterList }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "BK VV", field: "BKVV", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.BKVVstringTypeValueFormatter(params); }, width: 100, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK POR", field: "BKPOR", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOR"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK POL", field: "BKPOL", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOL"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK POD", field: "BKPOD", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKPOD"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK DEL", field: "BKDEL", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKDEL"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "BK Customer", field: "BKCustomer", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BKCustomer"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Trip Start", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTripStartForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TripStart", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "TripStart"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Trip End ", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTripEndForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TripEnd", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "TripEnd"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                ]
            },
            {
                headerName: 'Report Date/Time and Location',
                children: [
                    //WI-26422
                    {
                        headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true,
                        resizable: true, valueGetter: (params) => {
                            return ReeferFormatters.EventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList,
                                self.state.reeferFormatter.EventMasterList, self.state.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts,
                                self.state.reeferFormatter.Ref_SensorAlerts);
                        },
                        cellRenderer: (params) => {
                            return ReeferFormatters.EventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList,
                                self.state.reeferFormatter.EventMasterList, self.state.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts,
                                self.state.reeferFormatter.Ref_SensorAlerts);
                        }, getQuickFilterText: (params) => {
                            return ReeferFormatters.EventDescriptionFormatters(params,
                                self.state.reeferFormatter.CustomerSpecificEventList, self.state.reeferFormatter.EventMasterList,
                                self.state.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.state.reeferFormatter.Ref_SensorAlerts);
                        }, width: 150, enableTooltip: true, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Event time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "EventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Event notes", field: "EventNotes", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EventNotes"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Door", field: "DoorOpen", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, getQuickFilterText: ReeferFormatters.doorQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return ReeferFormatters.doorFormatterFilter(params); } },
                        valueGetter: (params) => { return ReeferFormatters.DoorFormatterSorting(params); }, cellRenderer: ReeferFormatters.doorFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Door time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DoorEventDtm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDoorEventDtmForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DoorEventDtm"); }, cellRenderer: Formatters.dateTypeFormatter, width: 170, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device fence", field: "GeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "GeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence", field: "ServerGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofenceName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: ReeferFormatters.stringTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device fence ID", field: "Geofence", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Geofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Server fence ID", field: "ServerGeofence", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ServerGeofence"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Region Fence ID", field: "RegionGeofence", cellRenderer: ReeferFormatters.stringTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc coords", field: "GPSCoords", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: ReeferCellRenderer.GPSCoordsFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.reeferSecondsToTimeConverterFilter(params); }, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "City", field: "City", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "City"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "State", field: "State", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "State"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Country", field: "Country", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Country"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Zip", field: "Zip", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Zip"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Reefer Datalog Events',
                children: [
                    { headerName: "DL event", field: "DLEventMasterID", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.DLEventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList, self.state.reeferFormatter.EventMasterList); }, cellRenderer: (params) => { return ReeferFormatters.DLEventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList, self.state.reeferFormatter.EventMasterList); }, getQuickFilterText: (params) => { return ReeferFormatters.DLEventDescriptionFormatters(params, self.state.reeferFormatter.CustomerSpecificEventList, self.state.reeferFormatter.EventMasterList); }, width: 150, enableTooltip: true, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "DL event time", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterDLEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DLEventDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DLEventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Data 1", field: "DLParam1", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam1"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Data 2", field: "DLParam2", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam2"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Data 3", field: "DLParam3", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam3"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Data 4", field: "DLParam4", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam4"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Data 5", field: "DLParam5", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DLParam5"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 110, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
            },
            {
                headerName: 'Reefer Status and Sensor Reporting',
                children: [
                    { headerName: "Alarm", field: "AlarmsList", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.AlarmDescriptionSorting(params, self.state.reeferFormatter.AlarmMasterList); }, cellRenderer: (params) => { return ReeferCellRenderer.AlarmsDescriptionFormatter(params, self.state.reeferFormatter.AlarmMasterList); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Opr mode", field: "RunningMode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.OperatingModeFormatter(params); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Reefer data", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterUnitEventDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "UnitEventDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "UnitEventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T set ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SetPoint", width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T sup 1 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T sup 2 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SupplyTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SupplyTemp2", columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T rtn 1 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T rtn 2 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "ReturnTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "ReturnTemp2", columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T amb ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "AmbientTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "AmbientTemp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "RH set", field: "HumiditySetpoint", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HumiditySetpoint"); }, cellRenderer: ReeferFormatters.HumiditySetpointFormatter, getQuickFilterText: ReeferFormatters.HumiditySetpointFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "RH read", field: "Humidity", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.HumiditySettingFormatter(params); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CO2 set", field: "CO2Setpoint", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CO2 read", field: "CO2Reading", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CO2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "O2 set", field: "O2Setpoint", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Setpoint"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "O2 read", field: "O2Reading", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "O2Reading"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T evap in ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EvaporatorInletSensor"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EvaporatorInletSensor", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T evap out ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EvaporatorOutletSensor"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EvaporatorOutletSensor", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "P suc", field: "CompositeSuctionPressure", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompositeSuctionPressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T suc ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorSuctionTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorSuctionTemp", columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "P dis", field: "DischargePressure", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "DischargePressure"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T dis ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorDischargeTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorDischargeTemp", columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T dis 2 ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CompressorDischargeTemp2"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CompressorDischargeTemp2", columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T econ in ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EconomizerInTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EconomizerInTemp", width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },
                    { headerName: "T econ out ", enableRowGroup: false, cellClass: 'OneDecimal', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "EconomizerOutTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "EconomizerOutTemp", width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },
                    { headerName: "P cond", field: "CondenserPressure", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataPCondFormatter(params); }, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "T cond wall ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CondenserTemperature"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CondenserTemperature", columnGroupShow: 'open', width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "M cond", field: "CondenserFanOutPut", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CondenserFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Evap fan set", field: "EvaporatorFanSpeedControl", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EvaporatorFanSpeedControl"); }, columnGroupShow: 'open', cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "LS evap", field: "LowSpeedEvaporatorFanOutPut", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LowSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "HS evap", field: "HighSpeedEvaporatorFanOutPut", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HighSpeedEvaporatorFanOutPut"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Air pump hr", field: "AirPumpRunHours", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.AirPumpRunHoursSorting(params); }, cellRenderer: ReeferFormatters.AirPumpRunHoursFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },
                    { headerName: "Heat on", field: "HeaterOnTime", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HeaterOnTime"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open exp", field: "EvaporatorExpansionValveOpening", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenExpFormatter(params); }, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open suc", field: "SuctionModulationValveOpening", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataOpenSucFormatter(params); }, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open dis", field: "HotGasValveOpening", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "HotGasValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Open econ", field: "EconomizerValveOpening", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "EconomizerValveOpening"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Comp freq", field: "CompressorFrequency", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompressorFrequency"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Comp curr", field: "CompressorCurrent", enableRowGroup: false, cellClass: 'TwoDecimal', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "CompressorCurrent"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Comp hr", field: "CompressorRunHours", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.CompressorRunHoursSorting(params); }, cellRenderer: ReeferFormatters.CompressorRunHoursFormatter, columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CT state", field: "ColdTreatmentState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ColdTreatmentState"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "CT dur (d)", field: "CTDuration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CTDurationSorting(params); }, cellRenderer: ReeferFormatters.CTDurationFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' }, // RCNG-1818
                    { headerName: "CT max ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTTempLimit"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTTempLimit", width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },//RCNG-1818
                    { headerName: "CT final ", enableRowGroup: true, cellClass: 'OneDecimal', sortable: true, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "CTPostSetPoint"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "CTPostSetPoint", width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },//RCNG-1818
                    { headerName: "CT rem (hr)", field: "CTRemainingTime", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return Formatters.CTRemainingTimeSorting(params); }, cellRenderer: ReeferFormatters.CTRemainingTimeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' }, // RCNG-1818
                    { headerName: "CT Time", cellClass: 'myExcelStyle', enableRowGroup: true, sortable: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCTTimeForFilter(params); } }, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CTTime", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "CTTime"); }, cellRenderer: Formatters.dateTypeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "USDA 1", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA1Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA1Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA 2", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA2Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA2Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA 3", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "USDA3Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "USDA3Temp", width: 110, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "USDA 4 cargo ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "Cargo4Temp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "Cargo4Temp", width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Vent pos", field: "VentPositionSensorCMH", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VentPositionSensorCMH"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CA mode", field: "ControlledAtmosphereMode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.ControlledAtmosphereMode(params); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Bulb mode", field: "BulbMode", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BulbMode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "CA hr", field: "CARunHours", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.CARunHoursSorting(params); }, cellRenderer: ReeferFormatters.CARunHoursFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },
                    { headerName: "CA SW ver", field: "CASoftwareRevision", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.CASWVerSorting(params); }, cellRenderer: ReeferFormatters.CASWVerFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this), columnGroupShow: 'open' },
                    { headerName: "3 ph curr", field: "ThreePhaseCurrent", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.ThreePhaseCurrentSortingFieldName(params, "ThreePhaseCurrent"); }, cellRenderer: ReeferFormatters.Current3PhaseFormatter, columnGroupShow: 'open', width: 135, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Tot curr", field: "TotalCurrentDraw", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "TotalCurrentDraw"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 100, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "L1 (VAC)", field: "LineVoltage1", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage1"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "L2 (VAC)", field: "LineVoltage2", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage2"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "L3 (VAC)", field: "LineVoltage3", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "LineVoltage3"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    {
                        headerName: "EverFRESH", field: "EverFRESH", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, columnGroupShow: 'open',
                        getQuickFilterText: ReeferFormatters.everFreshQuickFilterFormatter,
                        filterParams: { valueGetter: params => { return ReeferFormatters.everFreshFormatterFilter(params); } },
                        valueGetter: (params) => { return ReeferFormatters.everFreshFormatterSorting(params); },
                        cellRenderer: ReeferFormatters.everFreshFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "VFD", field: "VFD", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "VFD"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "OEM PTI state", field: "TripWiseStatusDescription", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.TripWiseStatusSorting(params, self.state.reeferFormatter.TripWiseStatusList); }, cellRenderer: (params) => { return ReeferCellRenderer.TripWiseStatusFormatter(params, self.state.reeferFormatter.TripWiseStatusList); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "OEM PTI exp (d)", field: "TripWiseExpiration", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.TripWiseExpirationSorting(params); }, cellRenderer: ReeferFormatters.TripWiseExpirationFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "OEM PTI term start", field: "DimiStartAfter", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DimiStartAfter"); }, cellRenderer: ReeferCellRenderer.OEMPTITypeFormatter, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "OEM PTI term (d)", field: "DimiTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "OEM PTI term rem (d)", field: "DimiRemainTerm", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.DimiRemainTermSorting(params); }, cellRenderer: ReeferFormatters.DimiRemainTermFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    
                    { headerName: "PTI state", field: "PTIState", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.state.reeferFormatter.PreTripList); }, cellRenderer: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.state.reeferFormatter.PreTripList); }, getQuickFilterText: (params) => { return ReeferFormatters.PTIStateDescriptionFormatters(params, self.state.reeferFormatter.PreTripList); }, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI result", field: "PTResult", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, tooltip: Formatters.toolTipFormatter, valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); }, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI Type", field: "PTIType", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "PTIType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "PTI time", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "PTRDateTime"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Freq", field: "LineFrequency", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.LineFrequencySorting(params); }, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont s/n", field: "ControllerSerialNumber", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ControllerSerialNumber"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont time", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "DataLoggerDtm", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "DataLoggerDtm"); }, cellRenderer: Formatters.dateTypeFormatter, columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont SW version", field: "SoftwareRevision", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SoftwareRevision"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Cont set", field: "ControllerTypeSetting", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ControllerTypeSetting"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 90, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Fresh air type", field: "FreshAirType", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FreshAirType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                    { headerName: "Defrost int", field: "DefrostInterval", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DefrostInterval"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this), columnGroupShow: 'open' },
                    { headerName: "Tot pwr kWh", field: "PowerMeter", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.PowerMeterSorting(params); }, cellRenderer: ReeferFormatters.PowerMeterFormatter, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                ]
            },
            {
                headerName: "Device Status",
                children: [
                    //{ headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: ReeferFormatters.rcdPowerSourceFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device ID", field: "RCDID", enableRowGroup: false, sortable: true, filter: false, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device supply (V)", field: "ReeferACPowerLevel", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return ReeferFormatters.sensorDataSortingFieldName(params, "ReeferACPowerLevel"); }, cellRenderer: ReeferFormatters.sensorDataValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device FW ver", field: "RCDFirmwareVersion", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, cellRenderer: (params) => { return ReeferFormatters.FirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'MAIN'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device BL ver", field: "RCDBootloaderVersion", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, cellRenderer: (params) => { return ReeferFormatters.BootloaderFirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'BL'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device mesh FW ver", field: "RCDMeshFirmwareVersion", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, cellRenderer: (params) => { return ReeferFormatters.MeshFirmWareDescriptionFormatters(params, self.state.reeferFormatter.DeviceFirmwareVersions, 'MESH'); }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device temp ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "DeviceTemp"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "DeviceTemp", columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Device bat (V)", field: "BatteryVoltage", enableRowGroup: false, cellClass: 'bigInt', sortable: false, filter: false, resizable: true,
                        valueGetter: (params) => { return Formatters.BattVoltageSortingFieldName(params, "BatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.BatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    {
                        headerName: "Door bat (V)", field: "DoorSensorBatteryVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: false, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.DoorBattVoltageSortingFieldName(params, "DoorSensorBatteryVoltage"); },
                        filterParams: { valueGetter: params => { return Formatters.DoorBatteryVoltageFormatterForFilter(params); } },
                        cellRenderer: Formatters.BattVoltageValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Geofence revision", field: "RevisionNum", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RevisionNum"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MSISDN", field: "MSISDN", enableRowGroup: true, sortable: false, filter: true, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MSISDN"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, sortable: false, filter: true, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SIM_IMSI"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "ICCID", field: "ICCID", enableRowGroup: true, sortable: false, filter: true, resizable: true, cellClass: 'bigInt', columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ICCID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EUI"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MCC (country)", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, field: "CountryName", valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CountryName"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, valueGetter: (params) => { return Formatters.MNCSorting(params); }, cellRenderer: ReeferCellRenderer.MNCTypeFormatter, columnGroupShow: 'open', width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerLocalizationAreaCode"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 70, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, sortable: false, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerBaseStationID"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, columnGroupShow: 'open', width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Cell gen", field: "CellNetGeneration", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: false, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CellNetGeneration"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this) },
                    {
                        headerName: "Cell signal", field: "RSSI", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, valueGetter: (params) => { return Formatters.RSSISorting(params); },
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } }, cellRenderer: ReeferCellRenderer.RSSITypeFormatter, width: 80, onCellClicked: this.onCellClickedCopy.bind(this)
                    },
                    //{ headerName: "RFR Comms", field: "RCDRfrComErr", columnGroupShow: 'open', cellRenderer: ReeferFormatters.reeferCommsFormatter, width: 130, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device config", field: "DeviceConfig", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, filter: false, resizable: true, columnGroupShow: 'open', filterParams: { valueGetter: params => { return Formatters.GuestReeferModeFormatterForFilter(params); } }, cellRenderer: Formatters.GuestReeferModeFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Device type", field: "DeviceType", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, resizable: true, columnGroupShow: 'open', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DeviceType"); }, cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 120, onCellClicked: this.onCellClickedCopy.bind(this) }

                ]
            },
            {
                headerName: "Misc.",
                children: [
                    //{ headerName: "Cmd P", field: "PendingCommands", cellRenderer: ReeferFormatters.commandTypeFormatter, columnGroupShow: 'open', width: 50, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Cmd A", field: "ActiveCommands", cellRenderer: ReeferFormatters.commandTypeFormatter, columnGroupShow: 'open', width: 50, onCellClicked: this.onCellClickedCopy.bind(this) },
                    //{ headerName: "Cmd E", field: "ErrorCommands", cellRenderer: ReeferFormatters.commandTypeFormatter, columnGroupShow: 'open', width: 50, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Receipt time", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: true, filter: false, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterModifiedDTTMForFilter(params); } }, resizable: true, headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "ModifiedDTTM", valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "ModifiedDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, columnGroupShow: 'open', width: 150, onCellClicked: this.onCellClickedCopy.bind(this) },
                    { headerName: "Comments", field: "CommentExists", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, valueGetter: (params) => { return Formatters.CommentExistsSorting(params); }, cellRenderer: ReeferCellRenderer.CommentExistsFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this) }
                ]
                //},
                //{
                //    headerName: 'Device Sensor',
                //    children: [
                //        { headerName: "Temp Sup. 1 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SensorSupplyTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorSupplyTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) },
                //        { headerName: "Temp Rtn. 1 ", enableRowGroup: false, cellClass: 'myExcelStyle', sortable: false, resizable: true, headerValueGetter: Formatters.TempHeaderFormatter, valueGetter: (params) => { return ReeferFormatters.TemperatureSortingFieldName(params, "SensorReturnTemp1"); }, cellRenderer: ReeferFormatters.TemperatureValueFormatter, field: "SensorReturnTemp1", width: 120, onCellClicked: this.onCellClickedCopy.bind(this), cellStyle: this.italicizeGridRows.bind(this) }
                //    ]
            }
        ];
    }

    clearGridRowSelection(params: any) {
        self.props.renderClearSelection();
        params.api.deselectAll();
    }

    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });
        //
        //var maxRowGroupLimit = 4;
        //var current = params.columns.length;

        //if (current === maxRowGroupLimit) {
        //    
        //    groupingDisabled = true;
        //    PopupWindow.showErrorMessage("RowGroup!", "max limit reached, please remove a group before adding a new one");
        //    
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
        //if (current < maxRowGroupLimit && groupingDisabled) {
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
    }

    groupRowInnerRenderer(params) {
        // self.clearGridRowSelection(params);
        var fieldName = params.node.field;
        var fieldValue = params.node.key;
        //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "BatteryVoltage")
            return "*No " + columnDisplayName;
        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() == "DoorSensorBatteryVoltage")
            return "*No " + columnDisplayName;
        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "TripWiseExpiration" && fieldName.toString().trim() != "HumiditySetpoint") // RCNG-169
            return "OOR";
        if (fieldValue == "-NA-" || fieldValue == "null")
            return "*No " + columnDisplayName;

        if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "HumiditySetpoint")
            return "OOR";

        //if (fieldName.toString() == "EventDTTM" || fieldName.toString() == "UnitEventDTTM" || fieldName.toString() == "PTRDateTime" || fieldName.toString() == "DataLoggerDtm" || fieldName.toString() == "ModifiedDTTM")
        //    return Formatters.dateTypeFormatterGrouping(fieldValue);

        switch (fieldName.toString().trim()) {
            case "RunState":
                return ReeferCellRenderer.RunStateFormatterGrouping(fieldValue);
            //case "AssetState":
            //    return Formatters.AssetStateFormatterGrouping(fieldValue);//added Asset State
            case "MASeverityLevel":
                return ReeferCellRenderer.StatusIndicatorALMFormatterGrouping(fieldValue);
            case "DevicePowerSourceCd":
                return ReeferCellRenderer.PowerStateFormatterGrouping(fieldValue);
            case "CCSeverityLevel":
                return ReeferCellRenderer.CargoCareFormatterGrouping(fieldValue);
            case "VesselCd":
                return fieldValue == "-NA-" ? "No VSL" : fieldValue;
            case "TripStatusCdAndDFlag":
                return ReeferCellRenderer.TripStatusFormatterGrouping(fieldValue);
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "ReeferOEMTypeCd":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "RSSI":
                return ReeferCellRenderer.RSSIFormatterGrouping(fieldValue);
            case "PTIState":
                return (fieldValue == "" || fieldValue == null) ? '-NA-' : fieldValue;
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "CommentExists":
                return ReeferCellRenderer.CommentExistsGrouping(fieldValue);
            case "PTResult":
                return ReeferCellRenderer.PTResultGrouping(fieldValue);
            /* RCNG 108 start*/
            case "AlarmsList":
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return ReeferCellRenderer.AlarmDescriptionGroupingFormatter(fieldValue, DeviceType, self.state.reeferFormatter.AlarmMasterList);
                }
            /* RCNG 108 end*/
            //case "Humidity":
            //    return Formatters.HumidityGrouping(params);
            //case "CondenserPressure":
            //    return Formatters.sensorDataPCondGrouping(params);
            //case "EvaporatorExpansionValveOpening":
            //    return Formatters.sensorDataOpenExpGrouping(params);
            //case "SuctionModulationValveOpening":
            //    return Formatters.sensorDataOpenSucGrouping(params);
            //case "ControlledAtmosphereMode":
            //    return Formatters.ControlledAtmosphereModeGrouping(params);
            case "TripWiseExpiration": // RCNG-169
                return Formatters.TripWiseExpirationGrouping(fieldValue);
            case "DimiRemainTerm":
                return Formatters.DimiRemainTermGrouping(fieldValue);
            case "DimiTerm":
                return Formatters.DimiTermTermGrouping(fieldValue);
            case "CTDuration": // RCNG-1818
                return Formatters.CTDurationGrouping(params);
            case "CTRemainingTime": // RCNG-1818
                return Formatters.CTRemainingTimeGrouping(params);
            //case "RunningMode":
            //    return Formatters.RunningModeGrouping(fieldValue);
            case "Cargo4Temp":
            case "USDA3Temp":
            case "USDA2Temp":
            case "USDA1Temp":
            case "SetPoint":
            case "SupplyTemp1":
            case "SupplyTemp2":
            case "ReturnTemp1":
            case "AmbientTemp":
            case "ReturnTemp2":
            case "EvaporatorTemp":
            case "CompressorSuctionTemp":
            case "CompressorDischargeTemp":
            case "EvaporatorInletSensor": 
            case "EvaporatorOutletSensor":
            case "CompressorDischargeTemp2":
            case "EconomizerInTemp": 
            case "EconomizerOutTemp":
            case "CondenserTemperature":
            case "DeviceTemp":
            case "SensorReturnTemp1":
            case "SensorSupplyTemp1":
            case "CTTempLimit"://RCNG-1818
            case "CTPostSetPoint"://RCNG-1818
                {
                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    return Formatters.TemperatureFormatterGrouping(fieldValue, fieldName, params, DeviceType);
                }
            case "TemperatureUnit":
                return Formatters.BookingTemperatureFormatterGrouping(fieldValue, fieldName, params);
            case "EventDTTM":
            case "UnitEventDTTM":
            case "PTRDateTime":
            case "DataLoggerDtm":
            case "ModifiedDTTM":
            case "DLEventDTTM":
            case "DoorEventDtm":
            case "TripStart":
            case "TripEnd":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            case "HumiditySetpoint":
                {
                    var HumiditySetpointStatus;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        HumiditySetpointStatus = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HumiditySetpointStatus;
                    }
                    return Formatters.HumiditySetpointGrouping(fieldValue, HumiditySetpointStatus);
                }
               case "TripWiseStatusDescription":
                {
                    var ReeferOEMTypeCd; var DimiResultActuator; var DimiResultAlarm; var DimiResultOOR; var DimiResultTerm;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                        DimiResultActuator = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultActuator;
                        DimiResultAlarm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultAlarm;
                        DimiResultOOR = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultOOR;
                        DimiResultTerm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultTerm;
                    }
                return ReeferCellRenderer.TripWiseStatusGrouping(fieldValue,ReeferOEMTypeCd,DimiResultActuator,DimiResultAlarm,DimiResultOOR,DimiResultTerm);
                }
            case "DoorOpen":
                return ReeferFormatters.DoorFormatterGrouping(fieldValue);//RCNG-1106
            case "EverFRESH":
                return Formatters.EverFreshFormatterGrouping(fieldValue);
            case 'DimiStartAfter':
                return Formatters.OEMPTITypeFormatter(fieldValue);
            default:
                return fieldValue;

        }
    }

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    onFirstDataRendered(params) {
        GridReeferStatusToolBar.GetColumns(params);
        //this method content is commented for WI26449. user preference should not be applied for SSRM grid.
        //// GridReeferStatusToolBar.GetColumns(params);
        ////self.setState({ gridApiParams: params.api });
        //var rowGroupItems = [];
        //var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        //var request = RCUtils.FetchRequest(url);
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<any>)
        //    .then(data => {
        //        if (data.PreferenceData != null) {
        //            var preferenceData = JSON.parse(data.PreferenceData);
        //            rowGroupItems = preferenceData.SelectedRowGroups
        //            //if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
        //            //    self.state.gridApiParams.gridOptionsWrapper.columnController.setRowGroupColumns(rowGroupItems);
        //            //}
        //            if (preferenceData.colState != null && preferenceData.colState != undefined && preferenceData.colState.length > 0) {
        //                var previousColState = preferenceData.colState;

        //                //self.state.gridApiParams.gridOptionsWrapper.columnController.setColumnState(preferenceData.colState);
        //                self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState({ state: preferenceData.colState, applyOrder: false, });
        //                //self.state.gridApiParams.gridOptionsWrapper.columnController.applyColumnState(preferenceData.colState);
        //            }
        //        }
        //    });

    }

    refreshStatusGrid() {
        //$('#globalLoader').show();
        //ReeferToggleButtonsFilter.ClearToggleFilters();
        selectedRowIndex = -1;
        this.GetCCprofileCode();//RCNG-713
        this.props.clearGridHeaderExtension();
        ReeferHistoryGrid.ClearHistoryGridData();
        this.setState({
            selectedItems: [],
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: '',
            modelTitleReport: '',
            popUpHtmlReport: ''
        }, () => {
            //self.state.gridApiParams.refreshServerSideStore();
            //self.state.gridApiParams.purgeServerSideCache();
            //gridOptions.api.purgeServerSideCache(). 
            //ReeferStatusSSRMGrid.ApplyReeferSearchFilter(self.props.statusFilter);
            ReeferStatusSSRMGrid.ApplyReeferSearchFilter(self.state.tempFilters);
            
        });
    }

    static refreshDashboardGrid() {
        self.refreshStatusGrid();
    }

    static refreshToggleFilters() {
        if (self != undefined) {
            if (self.state.ToggleSearchParams != undefined && self.state.ToggleSearchParams != null)
                self.setState({ ToggleSearchParams: null });
            self.setState({ rowData: [] });
        }
    }
    closeToolBarGridPreferenceModel() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }
    ComponentRenderingForCommands(popUpName: string, userData: any) {

        switch (popUpName) {

            case 'SendEmail':
                return <EmailControlExcelPreference reeferStatusResult={self.state.selectedItems} columnDefinition={this.state.columnDefs}
                    colDefs2={columnDefs2} parentchild={"C"} formName={"ReeferGrid"} FunctionID={functionId}
                    gridApiParams={self.state.gridApiParams} onlyselected={true}
                    widgetId={4} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    isIncludeRowGroup={self.state.gridApiParams.gridOptionsWrapper == undefined
                        && self.state.gridApiParams.gridOptionsWrapper == null ? false :
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false} sensorData={reeferAssetSensors}/>
            case 'Export':
                return <ExportToExcelConfirmationWindow formName={"ReeferGrid"} functionId={functionId} gridApiParams={self.state.gridApiParams} IsServerSideEnabled={self.state.showServerSideGrid}
                    gridData={self.state.selectedItems} colDefs={this.state.columnDefs} colDefs2={columnDefs2}
                    widgetId={4} dashboardPreferenceId={this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    parentchild={"C"} formname={"ReeferGrid"} onlyselected={true} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} sensorData={reeferAssetSensors}/>;
            case 'Ping':
                return <PingControl reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></PingControl>;
            case 'ChangeTempSetPoint':
                return <TempSetPoint reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></TempSetPoint>;
            case 'ChangeHumiditySetPoint':
                return <HumiditySetPoint reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></HumiditySetPoint>;
            case 'ChangeO2SetPoint':
                return <O2SetPoint reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></O2SetPoint>;
            case 'ChangeCO2SetPoint':
                return <CO2SetPoint reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></CO2SetPoint>;
            case 'ChangeControlledAtmosphere':
                return <ControlledAtmosphere reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} starCoolOem={this.state.isStarCoolOem} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ControlledAtmosphere>;
            case 'GetDLTraditional':
                return <TraditionalDataDownload reeferData={self.state.selectedItems} reeferFormatter={self.state.reeferFormatter} refreshGrid={"home"} useremail={userEmail} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}
                    customerId={custId} dCXDownloads={dCXDownloads} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></TraditionalDataDownload>;
            case 'PreTrip':
                return <PreTrip reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} preTripCmd={self.state.pretripCmd} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></PreTrip>;
            case 'StopPTI':
                return <StopPTI reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></StopPTI>;
            case 'SchedulePreTrip':
                return <ScheduledPreTrip reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ScheduledPreTrip>;
            case 'GetPTI':
                return <LastPretripResult reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} useremail={userEmail} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}
                    customerId={custId} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></LastPretripResult>;
            case 'RebootReefer':
                return <RebootReeferController reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></RebootReeferController>;
            case 'ChangeDatalogInterval':
                return <ChangeDataLogInterval reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeDataLogInterval>;
            case 'ChangeReeferId':
                return <ChangeReeferId reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReeferId>;
            case 'ChangeReportingInterval':
                return <ChangeReportingInterval reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReportingInterval>;
            case 'QueryReeferInventory':
                return <QueryReeferInventory reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></QueryReeferInventory>;
            case 'UpdateModelConfiguration':
                return <UpdateModelConfiguration reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></UpdateModelConfiguration>;
            case 'VerifyModelValidity':
                return <VerifyModelValidity reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></VerifyModelValidity>;
            case 'SyncReeferClock':
                return <SyncReeferClock reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></SyncReeferClock>;
            case 'StartDeforst':
                return <StartDeforst reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></StartDeforst>;
            case 'ChangeDeforstInterval':
                return <ChangeDeforstInterval reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} isChangeDeforstInterval={self.state.isChangeDeforstInterval} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeDeforstInterval>;
            case 'AssignPanId':
                return <AssignPANID reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AssignPANID>;
            case 'GuestReeferConfiguration':
                return <GuestReeferConfiguration reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'CreateTrip':
                return <CreateTrip refreshStatusGrid={self.refreshStatusGrid.bind(this)} refreshGrid={"home"} reeferData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'TripStatus':
                return <TripStatus refreshStatusGrid={self.refreshStatusGrid.bind(this)} refreshGrid={"home"} reeferData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'ClearDeviation':
                return <TripDeviation refreshStatusGrid={self.refreshStatusGrid.bind(this)} reeferData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'AssignBooking':
                return <AssignBookingSystem reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatusGrid"} CustomerAccessData={customerAccessData} IsTriggered={"false"} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AssignBookingSystem>;
            case 'UnAssignBooking':
                return <UnAssignBookingSystem reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatusGrid"} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></UnAssignBookingSystem>;
            case 'ViewBooking':
                return <ViewBookingDetails reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatusGrid"} ViewBookingData={viewBookingData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ViewBookingDetails>;
            case 'EditBooking':
                return <EditBookingSystem reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatusGrid"} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></EditBookingSystem>;
            case 'AssignCustomer':
                return <AssignToCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'UnAssignCustomer':
                return <UnassignReefersFromCustomer refreshStatusGrid={self.refreshStatusGrid.bind(this)} SelectedReefersData={self.state.selectedItems} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'ControllerSwap':
                return <PopupConfirm reeferData={self.state.selectedItems} ForwardCommandUnits={self.getForwardCommandUnits.bind(this)} refreshStatusGrid={self.refreshStatusGrid.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)} />;
            case 'ChangeReeferClockSyncSettings':
                return <ChangeReeferClockSyncSetting reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeReeferClockSyncSetting>;
            case 'Zigbee':
                return <ChangeZigbeeSettings reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ChangeZigbeeSettings>;
            case 'AutoConfig':
                return <AutoConfiguration reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AutoConfiguration>;
            case 'AssetConfig':
                return <AssetConfiguration reeferData={self.state.selectedItems} reeferFormatter={self.state.reeferFormatter} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AssetConfiguration>
            case 'MSC':
                return <MultipleSetpoints reeferData={self.state.selectedItems} reeferFormatter={self.state.reeferFormatter} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></MultipleSetpoints>;
            case 'ACT':
                return <AutomaticColdTreatment reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></AutomaticColdTreatment>;
            case 'GetFreshAirType':
                return <GetFreshAirType reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></GetFreshAirType>;
            case 'SetFreshAirType':
                return <SetFreshAirType reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></SetFreshAirType>;
            case 'DeviceReset':
                return <DeviceReset reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></DeviceReset>;
            case 'DeviceHardReset':
                return <DeviceHardReset reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></DeviceHardReset>;
            case 'GetAssetId':
                return <ReeferGetAssetId reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></ReeferGetAssetId>;
            case 'GetTWR':
                return <TripWiseReport reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} useremail={userEmail} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}
                    customerId={custId} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)}></TripWiseReport>;
            case 'EnableDoorSensor':
                return <EnableDoorSensor reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></EnableDoorSensor>;
            case 'NewUnAssignBooking':
                return <NewBookingUnAssign reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatus"} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></NewBookingUnAssign>;
            case 'EditVoyage':
                return <EditVoyageVVC reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshStatusGrid={self.refreshStatusGrid.bind(this)} UserID={userData.UserId} formname={"ReeferStatus"} CustomerAccessData={customerAccessData} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></EditVoyageVVC>;
            case 'DS':
                return <DimiSetting reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></DimiSetting>;
            case 'IntelligentPTIFunction':
                return <IntelligentPTIFunction reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></IntelligentPTIFunction>;
            case 'FanSpeed':
                return <FanSpeed reeferFormatter={self.state.reeferFormatter} reeferData={self.state.selectedItems} refreshGrid={"home"} VCCheckBoxInfo={self.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={self.UpdateVCCheckBoxInfo.bind(this)} IsCommandIssued={self.UpdateIsCommandIssued.bind(this)} PrevSelectedItems={self.UpdatePrevSelectedItems.bind(this)}></FanSpeed>;
        }
    }

    RenderContextMenuPopUp(popUpName: string, isCommands: boolean) {
        var reeferData = self.state.selectedItems;
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var filterSet: server.USP_UnitCurrentConditionUI_Model[];
        filterSet = reeferData;
        var filterParams = JSON.stringify(filterSet);
        var checkBoxInfo = this.state.VCCheckBoxInfo;
        if (isCommands) {
            if (reeferData != undefined && reeferData != null) {
                if (popUpName == "GetDLTraditional" || popUpName == "SchedulePreTrip") {
                    checkBoxInfo.disableVCOption = true;
                    checkBoxInfo.enableVCCheckBox = false;
                    checkBoxInfo.disableVCCheckBoxOption = true;
                    checkBoxInfo.disableVCDropDown = true;
                    checkBoxInfo.selectedVCData = null;
                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData, checkBoxInfo) }, () => { self.props.getCommandPopupTitle(this.state.modelTitle); self.props.getCommandPopupContent(this.state.popUpHtml); });
                    $('#btnTriggerPopup').click();
                }
                else {
                    $('#globalLoader').show();
                    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/CheckIsMsgFromVessel', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            var vesselid = data;
                            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetVesselInformation?customerID=' + custId;
                            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleError)
                                .then(response => response.json() as Promise<server.VesselInformation[]>)
                                .then(result => {
                                    checkBoxInfo.dropDownVCData = result;
                                    if (result.length > 0) {
                                        if (vesselid == "-1") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = true;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                        else if (vesselid == "0") {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = false;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = true;
                                            checkBoxInfo.selectedVCData = null;
                                            checkBoxInfo.isVCMessage = false;
                                        }
                                        else {
                                            checkBoxInfo.disableVCOption = false;
                                            checkBoxInfo.enableVCCheckBox = true;
                                            checkBoxInfo.disableVCCheckBoxOption = false;
                                            checkBoxInfo.disableVCDropDown = false;
                                            checkBoxInfo.selectedVCData = checkBoxInfo.dropDownVCData.find(d => d.VesselId == parseInt(vesselid));
                                            checkBoxInfo.isVCMessage = true;
                                        }
                                    }
                                    else {
                                        checkBoxInfo.disableVCOption = true;
                                        checkBoxInfo.enableVCCheckBox = false;
                                        checkBoxInfo.disableVCCheckBoxOption = true;
                                        checkBoxInfo.disableVCDropDown = true;
                                        checkBoxInfo.selectedVCData = null;
                                    }
                                    self.setState({ VCCheckBoxInfo: checkBoxInfo });
                                    $('#globalLoader').hide();
                                    self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) }, () => { self.props.getCommandPopupTitle(this.state.modelTitle); self.props.getCommandPopupContent(this.state.popUpHtml); });
                                    $('#btnTriggerPopup').click();
                                });
                        });
                }
            }
        }
        else {
            if (popUpName == "TripStatus") {
                this.setState({
                    modelTitle: 'Trip Status' + " - " + this.state.selectedItems[0].ReeferID
                });
            }
            self.setState({ popUpHtml: self.ComponentRenderingForCommands(popUpName, userData) }, () => {
                self.props.getCommandPopupTitle(this.state.modelTitle);
                self.props.getCommandPopupContent(this.state.popUpHtml);
            });
            $('#btnTriggerPopup').click();
        }
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        self.setState({ VCCheckBoxInfo: VCInfo });
    }

    popUpGetPTIReport() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + reeferData[0].ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ PTReport: result }, () => { self.props.getCommandPopupPTReport(this.state.PTReport); });
                    this.setState({ ReportReeferId: reeferData[0].ReeferID }, () => { self.props.getCommandPopupReportReeferId(this.state.ReportReeferId); });
                    $('#globalLoader').hide();
                    if (this.state.PTReport == null || this.state.PTReport == '')
                        PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
                    else {
                        this.setState({ modelTitle: 'Pre-Trip Report', popUpHtml: <div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} /> }, () => { self.props.getCommandPopupTitleReport(this.state.modelTitle); self.props.getCommandPopupContentReport(this.state.popUpHtml); });
                        $('#btnTriggerReport').click();
                    }
                });
        }
    }

    popUpGetTWReport() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetTripWISEReport?containerID=' + reeferData[0].ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ TWReport: result, ReportReeferId: reeferData[0].ReeferID }, () => { this.bindTWReport(); });
                });
        }
    }
    bindTWReport() {
        self.props.getCommandPopupTWReport(this.state.TWReport);
        self.props.getCommandPopupReportReeferId(this.state.ReportReeferId);
        $('#globalLoader').hide();
        if (this.state.TWReport == null || this.state.TWReport == '')
            PopupWindow.showErrorMessage("Alert", "No TripWISE reports have been collected for this reefer. Execute the ‘Get TripWISE Report’ command to collect the latest available report.");
        else {
            this.setState({ modelTitle: 'TripWISE Report', popUpHtml: <div dangerouslySetInnerHTML={{ __html: this.state.TWReport }} /> }, () => { self.props.getCommandPopupTitleReport(this.state.modelTitle); self.props.getCommandPopupContentReport(this.state.popUpHtml); });
            $('#btnTriggerReportTW').click();
        }
    }

    popUpPing() {
        self.setState({ modelTitle: 'Ping' });
        self.RenderContextMenuPopUp('Ping', true);
    }
   
    popUpSendEmail() {
        self.setState({ modelTitle: 'Send Email' });
        self.RenderContextMenuPopUp('SendEmail', false);
    }

    popUpExport() {
        self.setState({ modelTitle: 'Export' });
        self.RenderContextMenuPopUp('Export', false);
    }

    popUpChangeTempSetPoint() {
        var IsValid = CommonActions.validateCommandSupport('SET', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Change Temperature Setpoint' });
            self.RenderContextMenuPopUp('ChangeTempSetPoint', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpHumiditySetPoint() {
        var IsValid = CommonActions.validateCommandSupport('HUM', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);
            var oemDaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

            if (oemDaikinCount > 0 && oemDaikinCount != self.state.selectedItems.length)
                PopupWindow.showErrorMessage("Alert", "Selected reefers must be of the same OEM type.");
            else {
                if (carrrierCount <= 0) {
                    self.setState({ modelTitle: 'Change Humidity Setpoint' });
                    self.RenderContextMenuPopUp('ChangeHumiditySetPoint', true);
                }
                else if (carrrierCount >= 1) {
                    var isGuestFound = 0;
                    $.each(self.state.selectedItems, function (i, val) {
                        isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C'? isGuestFound + 1 : isGuestFound;
                    });

                    if (isGuestFound > 0) {
                        PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                    }
                    else {
                        self.setState({ modelTitle: 'Change Humidity Setpoint' });
                        self.RenderContextMenuPopUp('ChangeHumiditySetPoint', true);
                    }
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpO2SetPoint() {
        var IsValid = CommonActions.validateCommandSupport('ORC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);
            var StarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
            var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);

            if (DaikinCount >= 1 || StarCoolCount >= 1) {
                var isSekstantFound = 0;
                $.each(self.state.selectedItems, function (i, val) {
                    isSekstantFound = val.DeviceType.trim() == 'Sekstant' ? isSekstantFound + 1 : isSekstantFound;
                });
                if (isSekstantFound > 0 && StarCoolCount == self.state.selectedItems.length) {
                    self.setState({ modelTitle: 'Change O2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeO2SetPoint', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin and Star Cool OEMs.");
            }
            else if (carrrierCount >= 1) {
                var isGuestFound = 0;
                $.each(self.state.selectedItems, function (i, val) {
                    isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C' ? isGuestFound + 1 : isGuestFound;
                });

                if (isGuestFound > 0) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                }
                else {
                    self.setState({ modelTitle: 'Change O2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeO2SetPoint', true);
                }
            }
            else {
                self.setState({ modelTitle: 'Change O2 Setpoint' });
                self.RenderContextMenuPopUp('ChangeO2SetPoint', true);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpCo2SetPoint() {
        var IsValid = CommonActions.validateCommandSupport('CO2', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);
            var StarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
            var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);

            if (DaikinCount >= 1 || StarCoolCount >= 1) {
                var isSekstantFound = 0;
                $.each(self.state.selectedItems, function (i, val) {
                    isSekstantFound = val.DeviceType.trim() == 'Sekstant' ? isSekstantFound + 1 : isSekstantFound;
                });
                if (isSekstantFound > 0 && StarCoolCount == self.state.selectedItems.length) {
                    self.setState({ modelTitle: 'Change CO2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeCO2SetPoint', true);
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin and Star Cool OEMs.");
            }
            else if (carrrierCount >= 1) {
                var isGuestFound = 0;
                $.each(self.state.selectedItems, function (i, val) {
                    isGuestFound = val.DeviceConfig == true ? isGuestFound + 1 : isGuestFound;
                });

                if (isGuestFound > 0) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                }
                else {
                    self.setState({ modelTitle: 'Change CO2 Setpoint' });
                    self.RenderContextMenuPopUp('ChangeCO2SetPoint', true);
                }
            }
            else {
                self.setState({ modelTitle: 'Change CO2 Setpoint' });
                self.RenderContextMenuPopUp('ChangeCO2SetPoint', true);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }


    popUpChangeToChilled() {
        var IsValid = CommonActions.validateCommandSupport('SCH', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var oemTypeCount = CommonActions.validateOEMType('S', self.state.selectedItems);

            if (oemTypeCount >= 1) {
                var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCH', self.state.selectedItems, self.props.reeferConfigTypes);

                if (oemValidationCount == oemTypeCount) {
                    self.setState({ pretripCmd: 'StartChilledPTI', modelTitle: 'Start Chilled Pre-Trip' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Star Cool OEM.");
                }
            }
            else {
                self.setState({ pretripCmd: 'StartChilledPTI', modelTitle: 'Start Chilled Pre-Trip' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeToChilledandCA() {
        var IsValid = CommonActions.validateCommandSupport('SCC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var oemTypeCount = CommonActions.validateOEMType('D', self.state.selectedItems);

            if (oemTypeCount >= 1) {
                var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCC', self.state.selectedItems, self.props.reeferConfigTypes);

                if (oemValidationCount == oemTypeCount) {
                    self.setState({ pretripCmd: 'StartChilledCAPTI', modelTitle: 'Start Chilled and CA Pre-Trip' });
                    self.RenderContextMenuPopUp('PreTrip', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for this combination of OEM Model and Software.");
                }
            }
            else {
                self.setState({ pretripCmd: 'StartChilledCAPTI', modelTitle: 'Start Chilled and CA Pre-Trip' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeToFrozen() {
        var IsValid = CommonActions.validateCommandSupport('SFR', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ pretripCmd: 'StartFrozenPTI', modelTitle: 'Start Frozen Pre-Trip' });
            self.RenderContextMenuPopUp('PreTrip', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeToCA() {
        var IsValid = CommonActions.validateCommandSupport('SCT', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCT', self.state.selectedItems, self.props.reeferConfigTypes);

            if (DaikinCount == self.state.selectedItems.length) {
                self.setState({ pretripCmd: 'StartCAPTI', modelTitle: 'Start CA Pre-Trip' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeToCAFullPTI() {
        var IsValid = CommonActions.validateCommandSupport('SCF', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCF', self.state.selectedItems, self.props.reeferConfigTypes);

            if (DaikinCount == self.state.selectedItems.length) {
                self.setState({ pretripCmd: 'StartCAFullPTI', modelTitle: 'Start CA Full' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeToCAFunctionTest() {
        var IsValid = CommonActions.validateCommandSupport('SFT', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var StarCoolCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SFT', self.state.selectedItems, self.props.reeferConfigTypes);
            if (StarCoolCount == self.state.selectedItems.length) {
                self.setState({ pretripCmd: 'StartCAFunctionTest', modelTitle: 'Start CA Function Test' });
                self.RenderContextMenuPopUp('PreTrip', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpControlledAtmosphere() {
        var IsValid = CommonActions.validateCommandSupport('SCA', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var oemStarCoolCount = CommonActions.validateOEMType('S', self.state.selectedItems);
            var oemDaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

            if (oemStarCoolCount == self.state.selectedItems.length) {
                if (this.props.refApplicationParams != null && this.props.refApplicationParams != undefined) {
                    if (this.props.refApplicationParams.ValidateCACommand != null && this.props.refApplicationParams.ValidateCACommand != undefined) {
                        if (this.props.refApplicationParams.ValidateCACommand == "true") {
                            var oemValidationCount = CommonActions.validateSpecificOEMTypeForCommand('S', 'SCA', self.state.selectedItems, self.props.reeferConfigTypes);

                            if (oemValidationCount == self.state.selectedItems.length) {
                                self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                            }
                            else {
                                PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
                            }
                        }
                        else {
                            self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                        }
                    }
                    else {
                        self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                    }
                }
                else {
                    self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: true }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                }
            }
            else if (oemDaikinCount == self.state.selectedItems.length) {
                var DaikinCount = CommonActions.validateSpecificOEMTypeForCommand('D', 'SCA', self.state.selectedItems, self.props.reeferConfigTypes);

                if (DaikinCount == self.state.selectedItems.length) {
                    self.setState({ modelTitle: 'Change Controlled Atmosphere', isStarCoolOem: false }, () => self.RenderContextMenuPopUp('ChangeControlledAtmosphere', true));
                }
                else
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
            }
            else if (oemStarCoolCount >= 1 || oemDaikinCount >= 1) {
                PopupWindow.showErrorMessage("Alert", "Selected reefers must be of the same OEM type.");
            }
            else {
                PopupWindow.showErrorMessage("Alert", "Command is not supported for TK and Carrier OEMs.");
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpDLTraditional(e) {
        var IsValid = CommonActions.validateCommandSupport('TDD', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateDLCommand(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Get Traditional Download' });
                self.RenderContextMenuPopUp('GetDLTraditional', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpPreTripFull() {
        var IsValid = CommonActions.validateCommandSupport('SFP', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartFullPTI');
            //self.setState({ pretripCmd: 'StartFullPTI', modelTitle: 'Start Full Pre-Trip' });            
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpPreTripShort() {
        var IsValid = CommonActions.validateCommandSupport('SSP', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartShortPTI');
            //self.setState({ pretripCmd: 'StartShortPTI', modelTitle: 'Start Short Pre-Trip' });            
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpFunctionTest() {
        var IsValid = CommonActions.validateCommandSupport('SCP', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var DaikinCount = CommonActions.validateOEMType('D', self.state.selectedItems);

            if (DaikinCount <= 0) {
                this.getCommandWindowText(self.state.selectedItems.map(x => x.ReeferOEMTypeCd), 'StartCAShortPTI');
                //self.setState({ pretripCmd: 'StartCAShortPTI', modelTitle: 'Start Function Test' });
            }
            else
                PopupWindow.showErrorMessage("Alert", "Command is not supported for Daikin OEM.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpStopPTI() {
        var IsValid = CommonActions.validateCommandSupport('SPP', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Stop Pre-Trip' });
            self.RenderContextMenuPopUp('StopPTI', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpSchedulePTI() {
        self.setState({ modelTitle: 'Scheduled Pre-Trip' });
        self.RenderContextMenuPopUp('SchedulePreTrip', true);
    }

    popUpGetPTI() {
        var IsValid = CommonActions.validateCommandSupport('LPR', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            if (self.state.selectedItems.filter(row => row.ReeferOEMTypeCd.trim() == 'D' && (row.UnitTypeCd == null || row.UnitTypeCd == "UK")).length == 0) {
                self.setState({ modelTitle: 'Get Last Pre-Trip Result' });
                self.RenderContextMenuPopUp('GetPTI', true);
            }
            else
                PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should have valid OEM Model.");
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpGetTWR() {
        var IsValid = CommonActions.validateCommandSupport('TWR', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Get TripWISE Report' });
            self.RenderContextMenuPopUp('GetTWR', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpRebootReefer() {
        var IsValid = CommonActions.validateCommandSupport('RFC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Reboot Reefer Controller' });
            self.RenderContextMenuPopUp('RebootReefer', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeDatalog() {
        var IsValid = CommonActions.validateCommandSupport('SDI', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateAllOEMs(self.state.selectedItems);
            var carrrierCount = CommonActions.validateOEMType('C', self.state.selectedItems);
            if (carrrierCount >= 1) {
                var isGuestFound = 0;
                $.each(self.state.selectedItems, function (i, val) {
                    isGuestFound = val.DeviceConfig == true && val.ReeferOEMTypeCd.trim() == 'C' ? isGuestFound + 1 : isGuestFound;
                });

                if (isGuestFound > 0) {
                    PopupWindow.showErrorMessage("Alert", "Command is not supported for Device Type CT3100 and OEM Type Carrier.");
                }
                else if (validationMessage.OpenCommandWindow) {
                    self.setState({ modelTitle: 'Change Datalog Interval' });
                    self.RenderContextMenuPopUp('ChangeDatalogInterval', true);
                }
                else {
                    PopupWindow.showErrorMessage("Alert", validationMessage.Message);
                }
            }
            else if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Change Datalog Interval' });
                self.RenderContextMenuPopUp('ChangeDatalogInterval', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeReeferId() {
        var IsValid = CommonActions.validateCommandSupport('WRC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Change Reefer ID' });
            self.RenderContextMenuPopUp('ChangeReeferId', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeReporting() {
        self.setState({ modelTitle: 'Set Reporting Interval' });
        self.RenderContextMenuPopUp('ChangeReportingInterval', true);
    }

    popUpQueryReefer() {
        var IsValid = CommonActions.validateCommandSupport('QRI', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Query Reefer Inventory' });
            self.RenderContextMenuPopUp('QueryReeferInventory', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpUpdateModelConfig() {
        var IsValid = CommonActions.validateCommandSupport('UMC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Update Model Configuration' });
            self.RenderContextMenuPopUp('UpdateModelConfiguration', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpVerifyModelValidity() {
        var IsValid = CommonActions.validateCommandSupport('VMV', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var TKReceiverCount = CommonActions.validateOEMType('TR', self.state.selectedItems);
            if (TKReceiverCount == self.state.selectedItems.length) {
                PopupWindow.showErrorMessage("Alert", "Command is not supported for TKReceiver OEM.");
            }
            else {
                self.setState({ modelTitle: 'Verify Model Validity' });
                self.RenderContextMenuPopUp('VerifyModelValidity', true);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpSyncReeferClock() {
        var IsValid = CommonActions.validateCommandSupport('SRC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Sync Reefer Clock' });
            self.RenderContextMenuPopUp('SyncReeferClock', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeReeferClockSyncSetting() {
        var IsValid = CommonActions.validateCommandSupport('RCS', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            self.setState({ modelTitle: 'Change Reefer Clock Sync Settings' });
            self.RenderContextMenuPopUp('ChangeReeferClockSyncSettings', true);
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpStartDeforst() {
        var IsValid = CommonActions.validateCommandSupport('DSC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateMultipleOEMs(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Start Defrost' });
                self.RenderContextMenuPopUp('StartDeforst', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpChangeDeforstInterval() {
        var IsValid = CommonActions.validateCommandSupport('CDI', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateStarCoolCarrierDaikinTypes(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                this.setState({ isChangeDeforstInterval: true });
                self.setState({ modelTitle: 'Change Defrost Interval' });
                self.RenderContextMenuPopUp('ChangeDeforstInterval', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpSetFreshAirType() {
        var IsValid = CommonActions.validateCommandSupport('SFA', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateCarrierDaikinThermoKingTypes(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Set - Fresh Air Type' });
                self.RenderContextMenuPopUp('SetFreshAirType', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpGetFreshAirType() {
        var IsValid = CommonActions.validateCommandSupport('GFA', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateCarrierDaikinThermoKingTypes(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Get - Fresh Air Type' });
                self.RenderContextMenuPopUp('GetFreshAirType', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);

            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpAssignPanId() {
        self.setState({ modelTitle: 'Assign PAN ID' });
        self.RenderContextMenuPopUp('AssignPanId', true);
    }

    popUpGuestReeferConfigCmd() {
        self.setState({ modelTitle: 'Guest Reefer configuration commands' });
        self.RenderContextMenuPopUp('GuestReeferConfiguration', true);
    }

    popAutoConfiguration() {
        if (self.state.selectedItems.length > 0) {
            var reeferData = self.state.selectedItems;
            var customerIdsCount = 0;
            var DeviceTypeCount = 0;

            $.each(reeferData, function (key, value) {
                var customerId = reeferData[0].CustomerID;
                if (value.CustomerID != customerId) {
                    customerIdsCount++;
                }
            });
            $.each(reeferData, function (key, value) {
                var DeviceType = reeferData[0].DeviceType;
                if (value.DeviceType != DeviceType) {
                    DeviceTypeCount++;
                }
            });
            if (customerIdsCount > 0) {
                PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should be of same customer.");
            }
            else if (DeviceTypeCount > 0) {
                PopupWindow.showErrorMessage("Alert", "Selected Reefer(s) should be of same device type.");
            }
            else {
                self.setState({ modelTitle: 'Device Configuration' });
                self.RenderContextMenuPopUp('AutoConfig', true);
            }
        };
    }

    popAssetConfiguration() {
        self.setState({ modelTitle: 'Asset Configuration' });
        self.RenderContextMenuPopUp('AssetConfig', true);
    }

    popUpMSC() {
        var IsValid = CommonActions.validateCommandSupport('MSC', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateDaikinThermoKingTypes(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Multiple Setpoint Change' });
                self.RenderContextMenuPopUp('MSC', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }

    popUpACT() {
        var IsValid = CommonActions.validateCommandSupport('ACT', self.state.selectedItems, self.props.reeferConfigTypes);
        if (IsValid) {
            var validationMessage = CommonActions.validateDaikinThermoKingTypes(self.state.selectedItems);

            if (validationMessage.OpenCommandWindow) {
                self.setState({ modelTitle: 'Automatic Cold Treatment' });
                self.RenderContextMenuPopUp('ACT', true);
            }
            else {
                PopupWindow.showErrorMessage("Alert", validationMessage.Message);
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "Command is not supported for OEM Model.");
    }
    popUpDIMISettings() {
        var validationMessage = CommonActions.validateDaikinDimiTypes(self.state.selectedItems);

        if (validationMessage.OpenCommandWindow) {
            self.setState({ modelTitle: 'DIMI Settings', OEM: validationMessage.OEM });
            self.RenderContextMenuPopUp('DS', true);
        }
        else {
            PopupWindow.showErrorMessage("Alert", validationMessage.Message);
        }
    }
    popUpIntelligentPTIFunction() {
        var validationMessage = CommonActions.validateDaikinTypes(self.state.selectedItems);

        if (validationMessage.OpenCommandWindow) {
            self.setState({ modelTitle: 'Intelligent PTI Function', OEM: validationMessage.OEM });
            self.RenderContextMenuPopUp('IntelligentPTIFunction', true);
        }
        else {
            PopupWindow.showErrorMessage("Alert", validationMessage.Message);
        }
    }
    popUpFanSpeed() {
        var validationMessage = CommonActions.validateDaikinTypes(self.state.selectedItems);

        if (validationMessage.OpenCommandWindow) {
            self.setState({ modelTitle: 'Fan Speed', OEM: validationMessage.OEM });
            self.RenderContextMenuPopUp('FanSpeed', true);
        }
        else {
            PopupWindow.showErrorMessage("Alert", validationMessage.Message);
        }
    }
    //RCNG-3 -start
    popUpRetire() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a retired asset does not appear in search results, nor does it contribute to the information collected by most dashboard widgets. Continue?",
            self.onYesRetire.bind(this),//RCNG-54
            self.onCancelRefreshStatusGrid.bind(this));//RCNG-54
    }
    popUpReactivate() {
        IsTriggered = false;
        RCNGWindow.ConfirmWindow.showConfirmBox("By default, a reactivated asset appears in search results and contributes to the information collected by most dashboard widgets. Continue?",
            self.onYesReactivate.bind(this),//RCNG-54
            self.onCancelRefreshStatusGrid.bind(this));//RCNG-54
    }
    onCancelRefreshStatusGrid() {
        RCNGWindow.ConfirmWindow.close();
    }
    onYesRetire() {
        if (!IsTriggered) {
            IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits() //RCNG-45
            //var reeferData = self.state.selectedItems;//RCNG-45
            //if (reeferData != undefined && reeferData != null) {//RCNG-45
            RCNGWindow.ConfirmWindow.close();
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/RetireAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })//RCNG-45
            //var url = Config.ApiBaseUrl + '/api/reeferstatus/RetireAsset?containerID=' + reeferData[0].ReeferID;//RCNG-45
            //var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });//RCNG-45
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Retired.");
                        self.refreshStatusGrid();
                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
            //}

        }
        //}//RCNG-45
    }
    onYesReactivate() {
        if (!IsTriggered) {
            IsTriggered = true;
            var commandUnits = this.getForwardCommandUnits()//RCNG-45
            //var reeferData = self.state.selectedItems;//RCNG-45
            //if (reeferData != undefined && reeferData != null) {//RCNG-45
            $('#globalLoader').show();
            RCNGWindow.ConfirmWindow.close();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReactivateAsset', { method: 'POST', body: JSON.stringify(commandUnits), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })//RCNG-45
            //var url = Config.ApiBaseUrl + '/api/reeferstatus/ReactivateAsset?containerID=' + reeferData[0].ReeferID;//RCNG-45
            //var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });//RCNG-45
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    $('#globalLoader').hide();
                    if (result === "success") {
                        PopupWindow.showErrorMessage("Alert", "Asset(s) Reactivated.");
                        self.refreshStatusGrid();

                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", "Error Occured.");
                    }
                });
            //}
        }
    }
    //RCNG-3 -end
    popUpGetAssetId() {
        self.setState({ modelTitle: 'Get Asset ID' });
        self.RenderContextMenuPopUp('GetAssetId', true);
    }

    popUpEnableDoorSensor() {
        self.setState({ modelTitle: 'Enable Door Sensor' });
        self.RenderContextMenuPopUp('EnableDoorSensor', true);
    }

    popUpCreateTrip() {
        self.setState({ modelTitle: 'Trip Details' });
        self.RenderContextMenuPopUp("CreateTrip", false);
    }

    popUpTripStatus() {
        self.setState({ modelTitle: 'Trip Status' });
        self.RenderContextMenuPopUp("TripStatus", false);
    }

    popUpClearDeviation() {
        self.setState({ modelTitle: 'Clear Deviation' });
        self.RenderContextMenuPopUp('ClearDeviation', false);
    }

    popUpViewBooking() {
        $('#globalLoader').show();
        viewBookingData = [];
        self.setState({ modelTitle: 'View Booking' });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingDataByNumber?BookingNumber=' + self.state.selectedItems[0].BookingNumber)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                viewBookingData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('ViewBooking', false);
            });
    }

    popUpAssignBooking() {
        $('#globalLoader').show();
        customerAccessData = [];
        self.setState({ modelTitle: 'Third-Party Access' });//Modified for RCNG-945
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].UnitMasterID.toString();
        }

        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.UnitMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('AssignBooking', false);
            });
    }

    popUpUnAssignBooking() {
        $('#globalLoader').show();
        self.setState({ modelTitle: 'Unassign Booking and Access' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].UnitMasterID.toString();
        }

        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.UnitMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('UnAssignBooking', false);
            });
    }
    popUpEditVoyage() {
        self.setState({ modelTitle: 'Edit Voyage' });
        self.RenderContextMenuPopUp('EditVoyage', false);
    }
    popUpNewUnAssignBooking() {
        $('#globalLoader').show();
        if (JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd == '3P')//Added for RCNG-975
            self.setState({ modelTitle: 'Unassign Booking' });
        else
        self.setState({ modelTitle: 'Unassign Booking and Access' });
        var selectedUnits = "";
        if (self.state.selectedItems.length > 1) {
            $.each(self.state.selectedItems, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = self.state.selectedItems[0].UnitMasterID.toString();
        }

        var filterUnitParams = JSON.stringify(self.state.selectedItems.map(x => x.UnitMasterID));
        var url = Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: filterUnitParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroupsBooking?selectedUnits=' + selectedUnits);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                customerAccessData = data;
                $('#globalLoader').hide();
                self.RenderContextMenuPopUp('NewUnAssignBooking', false);
            });
    }
   

    popUpControllerSwap() {
        self.setState({ modelTitle: 'Change Controller swap' });
        self.RenderContextMenuPopUp('ControllerSwap', false);
    }

    popUpZigbeeSettings() {
        self.setState({ modelTitle: 'Change Zigbee Config Settings' });
        self.RenderContextMenuPopUp('Zigbee', true);
    }

    popUpDeviceReset() {
        self.setState({ modelTitle: 'Device Reset' });
        self.RenderContextMenuPopUp('DeviceReset', true);
    }

    popUpDeviceHardReset() {
        self.setState({ modelTitle: 'Device Reset To Defaults' });
        self.RenderContextMenuPopUp('DeviceHardReset', true);
    }
    checkUnitAssignedToCargoCare(CCCustomerProfileId: any, customerProfileCode: any, newCustomerProfileCode: any) {
        if (customerProfileCode != null && customerProfileCode != "" && customerProfileCode != undefined) {
            IsTriggered = false;
            RCNGWindow.ConfirmWindow.showConfirmBox("The chosen profile " + newCustomerProfileCode + ", will replace any other profiles currently in use by the selected reefer(s). The reefer(s) will be unassigned from those profiles and all of their CargoCare alerts will be cleared prior to reassignment to " + newCustomerProfileCode + ". Continue?",
                self.onYesAssignToCargoCare.bind(this, CCCustomerProfileId),
                self.onCancelRefreshStatusGrid.bind(this));
        }
        else
            self.assignCargoCare(CCCustomerProfileId);
    }
    onYesAssignToCargoCare(CCCustomerProfileId: any) {
        if (!IsTriggered) {
            IsTriggered = true;

            RCNGWindow.ConfirmWindow.close();
            self.assignCargoCare(CCCustomerProfileId);
        }
    }
    assignToCargoCareSubMenu(customerProfileCode: any, params: any) {
        var cargoCareSubMenus: any = [];
        $.each(this.state.CargoCareProfiles, (index, item) => {
            var objCCSubMenu: any = {
                name: item.CargoCareCustomerProfileCode,
                action: () => {
                    //this.assignCargoCare(item.CargoCareCustomerProfileID);
                    self.checkUnitAssignedToCargoCare(item.CargoCareCustomerProfileID, customerProfileCode, item.CargoCareCustomerProfileCode);
                },
                disabled: UserRights.checkCCAssignSubMenuItemDisabled(params, item.CargoCareCustomerProfileID, 'AssigntoCargoCare')
            }
            cargoCareSubMenus.push(objCCSubMenu);
        });

        return cargoCareSubMenus;
    }

    ClearCargoCareAlertsSubMenu(selectedReeferData: any) {
        var ccAlertsSubMenus: any = [];
        var alarmsList = self.state.reeferFormatter.AlarmMasterList;
        if (selectedReeferData[0].CCAlarmsList != undefined && selectedReeferData[0].CCAlarmsList != null && selectedReeferData[0].CCAlarmsList != "") {
            var ccAlarms = selectedReeferData[0].CCAlarmsList.split(',');

            $.each(ccAlarms, function (index, item) {
                var lstAlerts = item.split(':');
                var almCd = lstAlerts[3] != "" ? lstAlerts[3].trim() : '';
               var alarmDescription = alarmsList.filter(e =>
                   e.AlarmCd === almCd);
                if (alarmDescription.length > 0) {
                    var objCCSubMenu: any = {
                        name: alarmDescription[0].AlarmAlias + " : " + alarmDescription[0].Description + " : " + lstAlerts[2],
                        action: () => {
                            self.clearActiveCargoCareAlert(alarmDescription[0].AlarmMasterID);
                        },
                        icon: ReeferCellRenderer.GetCargoCareAlmImg(lstAlerts[1]),
                    }
                    ccAlertsSubMenus.push(objCCSubMenu);

                }


            });

            if (ccAlertsSubMenus.length > 1) {
                var objCCAllSubMenuSep: any = 'separator';
                ccAlertsSubMenus.push(objCCAllSubMenuSep);
                var objCCAllSubMenu: any = {
                    name: "Clear All",
                    action: () => {
                        self.clearActiveCargoCareAllAlerts();
                    },
                    //disabled: UserRights.checkMenuItemDisabled(params, 'AssigntoCargoCare')
                }
                ccAlertsSubMenus.push(objCCAllSubMenu);
            }
        }
        return ccAlertsSubMenus;
    }
    
    assignCargoCare(CargoCareCustomerProfileID: any) {
        $('#globalLoader').show();
        //this.props.requestAssignCargoCare(this.getForwardCommandUnits());
        //this.refreshStatusGrid();
        var commandUnits = this.getCargoCareCommandUnits(null, CargoCareCustomerProfileID);
        var filterSet: server.ReeferCommandUnits[];
        filterSet = commandUnits;
        var filterParams = JSON.stringify(filterSet);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/AssignCargoCare', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(msg => {
                if (msg == "Cargo care assigned successfully.") {
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
                    this.refreshStatusGrid();
                }
            });

    }

    unAssignCaregoCare() {
        $('#globalLoader').show();
        //this.props.requestUnAssignCargoCare(this.getForwardCommandUnits());
        //this.refreshStatusGrid();

        var commandUnits = this.getForwardCommandUnits();
        var filterSet: server.ReeferCommandUnits[];
        filterSet = commandUnits;
        var filterParams = JSON.stringify(filterSet);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/UnAssignCargoCare', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(msg => {
                if (msg == "Cargo care unassigned successfully.") {
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
                    this.refreshStatusGrid();
                }
            });
    }
    clearActiveCargoCareAlert(alarmMasterId: any) {
        var commandUnits = this.getCargoCareCommandUnits(alarmMasterId, null);
        var filterSet: server.ReeferCommandUnits[];
        filterSet = commandUnits;
        var filterParams = JSON.stringify(filterSet);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ClearCargoCareAlert', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(msg => {
                if (msg == "Cargo care alert(s) cleared successfully.") {
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
                    this.refreshStatusGrid();
                }
            });
    }

    clearActiveCargoCareAllAlerts() {
        var commandUnits = this.getCargoCareCommandUnits(null, null);
        var filterSet: server.ReeferCommandUnits[];
        filterSet = commandUnits;
        var filterParams = JSON.stringify(filterSet);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ClearAllCargoCareAlerts', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(msg => {
                if (msg == "Cargo care alerts cleared successfully.") {
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
                    this.refreshStatusGrid();
                }
            });
    }
    clearSetPoint() {
        var commandUnits = this.getForwardCommandUnits();
        var filterSet: server.ReeferCommandUnits[];
        filterSet = commandUnits;
        var filterParams = JSON.stringify(filterSet);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ClearSetPoint', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(msg => {
                if (msg == "Clear set point is done") {
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.state.selectedItems });
                    this.refreshStatusGrid();
                }
            });
    }

    exportToExcel() {

        var arrData;
        if (self.state.selectedItems != null) {
            arrData = typeof self.state.selectedItems != 'object' ? JSON.parse(self.state.selectedItems) : self.state.selectedItems;
        }
        else {
            arrData = typeof this.state.rowData != 'object' ? JSON.parse(this.state.rowData) : this.state.rowData;
        }

        $("#globalLoader").show();
        var r = this.state.columnDefs;
        try {
            var formName = 'ReeferGrid';
            var sheetData = { HeaderData: [], ColumnData: [] };
            var uri = Excel.InitializeChildGridExportToExcel(arrData, r, formName);
            this.state.exportFields.ExportData = JSON.stringify(uri);
            sheetData = Excel.ConvertCSVToJSon(uri);
            GridReeferStatusToolBar.applySheetData(sheetData, formName);
        }
        catch (ex) {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Error in data export.");
        }
    }
    getCargoCareCommandUnits(alarmMasterId: any, CCCustomerProfileId: any) {
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var commandUnits = [];

        if (this.state.selectedItems.length > 0) {
            forEach(this.state.selectedItems, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userData.UserId,
                    "TripId": value.TripId,
                    "RCDReportingInterval": value.RCDReportingInterval,
                    "SetTemp": value.SetPoint,
                    "CustomerID": value.CustomerID,
                    "CCCustomerProfileId": CCCustomerProfileId,
                    "AlarmMasterId": alarmMasterId
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }

    getForwardCommandUnits() {
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        var userData = JSON.parse(sessionStorage.getItem('UserInfo'));
        var commandUnits = [];

        if (this.state.selectedItems.length > 0) {
            forEach(this.state.selectedItems, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userData.UserId,
                    "TripId": value.TripId,

                    "RCDReportingInterval": value.RCDReportingInterval,
                    "SetTemp": value.SetPoint,
                    "CustomerID": value.CustomerID
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, gridApiParams: any, isIncludeRowGroup:boolean, sensorData:any) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, gridApiParams, isIncludeRowGroup, reeferAssetSensors);
    }

    renderGridPreferenceDialog(functionId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, gridApiParams, formName);
    }
    renderExportToExcelDialog(functionId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData:any) {
        this.props.renderDataGridExportToExcelControl(functionId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, reeferAssetSensors);
    }

    filterReeferStatusGrid(searchParam: any) {
        self.setState({ ToggleSearchParams: searchParam });
        $('#globalLoader').show();
        ReeferCallout.ResetMapPushpins();
        var reeferData = [];
        var reeferSearchData = this.props.propsReeferData;
        if (!searchParam.AllReefer && !searchParam.Running && !searchParam.MissedRunning && !searchParam.Stopped && !searchParam.MissedStopped && !searchParam.AllMicroAlaram && !searchParam.MASevere && !searchParam.MAMinor && !searchParam.AllCargoCare && !searchParam.CCSevere && !searchParam.CCMinor && !searchParam.CCInformational) {
            reeferData.push(...reeferSearchData);
        }

        if (searchParam.AllReefer) {
            reeferData.push(...reeferSearchData);
        }

        if (searchParam.Running && !searchParam.AllReefer) {
            reeferData.push(...reeferSearchData.filter(x => x.RunState == "I"));
        }

        if (searchParam.MissedRunning && !searchParam.AllReefer) {
            reeferData.push(...reeferSearchData.filter(x => x.RunState == "S"));
        }

        if (searchParam.Stopped && !searchParam.AllReefer) {
            reeferData.push(...reeferSearchData.filter(x => x.RunState == "X"));
        }

        if (searchParam.MissedStopped && !searchParam.AllReefer) {
            reeferData.push(...reeferSearchData.filter(x => x.RunState == "O"));
        }

        if (searchParam.AllMicroAlaram) {
            reeferData.push(...reeferSearchData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && (x.MASeverityLevel == "1" || x.MASeverityLevel == "2")));
        }

        if (searchParam.MASevere && !searchParam.AllMicroAlaram) {
            reeferData.push(...reeferSearchData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && x.MASeverityLevel != "" && x.MASeverityLevel == "1"));
        }

        if (searchParam.MAMinor && !searchParam.AllMicroAlaram) {
            reeferData.push(...reeferSearchData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && x.MASeverityLevel != "" && x.MASeverityLevel == "2"));
        }

        if (searchParam.AllCargoCare) {
            reeferData.push(...reeferSearchData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && x.CCSeverityLevel != ""));
        }

        if (searchParam.CCSevere && !searchParam.AllCargoCare) {
            reeferData.push(...reeferSearchData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == "1")));
        }

        if (searchParam.CCMinor && !searchParam.AllCargoCare) {
            reeferData.push(...reeferSearchData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == "2")));
        }

        if (searchParam.CCInformational && !searchParam.AllCargoCare) {
            reeferData.push(...reeferSearchData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == "3")));
        }

        let reeferFilterData = uniq(reeferData);

        ReeferCallout.BindClusterMapPushpins(reeferFilterData, 'status', this.state.reeferFormatter);

        this.setState({
            rowData: reeferFilterData
        });
        setTimeout(() => {
            $('#globalLoader').hide();
        }, 500);

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != []) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }
    childHandler(dataFromChild) {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.setFilterModel({ "-": { filter: dataFromChild } })
        var finalData = [];
        var datasource = self.ServerSideDatasource(finalData);
        self.state.gridApiParams.setServerSideDatasource(datasource);
        //this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.setFilterModel({ "-": { filter: str } })
        // log our state before and after we updated it

    }

    onGridScroll(params: any) {
        $(".context-menu").hide();
        $("#contextmenu").hide();
    }
    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function (item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function () {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "ReeferStatusGrid");
            },
        });
        return finalMenuItem;
    }
    onColumnResized = (params: any) => {
        self.onSaveGridRowGroupState(params);
    }
    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                font: {
                    size: 12
                },
                alignment: {
                    horizontal: 'Left'
                }

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                },
                alignment: {
                    horizontal: 'Left'
                }
            },
            {
                id: 'OneDecimal',
                numberFormat: {
                    format: '0.0',
                },
                font: {
                    size: 12,
                },
                alignment: {
                    horizontal: 'Left'
                }
            },
            {
                id: 'TwoDecimal',
                numberFormat: {
                    format: '0.00',
                },
                font: {
                    size: 12,
                },
                alignment: {
                    horizontal: 'Left'
                },
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
               
            },
        ];
        return <div>
            <div className='dashboard-GridToolbar'>
                <GridReeferStatusToolBar
                    refreshGrid={this.refreshStatusGrid.bind(this)}
                    gridData={this.state.rowData}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    gridApiParams={this.state.gridApiParams}
                    parentchild={"C"}
                    formName={"ReeferStatusGrid"}
                    IsServerSideEnabled={this.state.showServerSideGrid}
                    sourceFrom='Dashboard'
                    sensorData={reeferAssetSensors}
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    validateRevisionNum={this.props.validateRevisionNum.bind(this)}
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)}
                />
                <div className='aggrid-icons'>
                    <button type="button" className="btn btn-outline-secondary clearselectionBtn"
                        //onClick={this.ClearSelection.bind(this)}
                        onClick={this.props.renderClearSelection.bind(this)}
                        title='Clear Selection'><span className='fa-regular fa-eraser'></span> </button>
                </div>
                {JSON.parse(sessionStorage.getItem('SSRM')) == false ?
                    <div className='dashboard-filters'>
                        <ReeferToggleButtonsFilter gridData={this.props.propsReeferData} filterReeferStatusGrid={this.filterReeferStatusGrid.bind(this)}></ReeferToggleButtonsFilter>
                    </div> : ''
                }
            </div>
            {
                <div className="ag-theme-fresh ReeferSSRMGrid Dashboard-Grid-height test " id='Grid-Align2'>
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        //rowData={this.state.rowData}
                        rowModelType={this.state.rowModelname}
                        serverSideStoreType={this.state.serverSideStoreType}
                        //serverSideStoreType={'Partial'}

                        onGridReady={this.onGridReadyServer}
                        animateRows={true}
                        getMainMenuItems={this.getMainMenuItems.bind(this)}
                        //rowGroupPanelShow={this.state.rowGroupPanelShow}
                        cacheBlockSize={250}
                        //maxBlocksInCache={1}
                        //autoGroupColumnDef={this.state.autoGroupColumnDef}
                        //suppressDragLeaveHidesColumns={true}
                        //suppressMakeColumnVisibleAfterUnGroup={true}
                        onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                        processCellForClipboard={this.ProcessCellForClipboard}
                        // groupDisplayType = 'groupRows'
                        enableRangeSelection={true}
                        pagination={true}
                        rowSelection={'multiple'}
                        //accentedSort={true}
                        rowDeselection={true}
                        onSelectionChanged={this.onGridSelectionChanged}
                        onDragStopped={this.onSavecolumnorder.bind(this)}
                        //groupRowRendererParams={groupRowRendererParams}
                        //groupRowInnerRenderer={this.groupRowInnerRenderer}
                        // onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                        // onColumnPinned={this.onSaveGridRowGroupState.bind(this)}
                        // onColumnResized={Formatters.debounce(this.onColumnResized, 1000)}
                        // getMainMenuItems={this.getMainMenuItems.bind(this)}
                        //defaultGroupOrderComparator={
                        //    function (nodeA, nodeB) {
                        //        if (nodeA.key < nodeB.key) {
                        //            return -1;
                        //        } else if (nodeA.key > nodeB.key) {
                        //            return 1;
                        //        } else {
                        //            return 0;
                        //        }
                        //    }
                        //}
                        allowContextMenuWithControlKey={true}
                        excelStyles={excelStyles}
                        getContextMenuItems={this.getReeferContextMenuItems}
                        paginationPageSize={this.state.pageSize}
                        onRowDataChanged={this.onRowDataChanged}
                        onPaginationChanged={this.onGridPaginationChanged}
                        frameworkComponents={this.state.frameworkComponents}
                        overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                        tooltipShowDelay={0}
                        tooltipHideDelay={8000}
                        onBodyScroll={this.onGridScroll}

                    >
                    </AgGridReact>
                </div>

            }
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="250">250</option>
                </select>
            </div>
            <div className='row' id="contextmenu">
                <button id="btnTrigger" className='btnContext' onClick={this.props.onOpenCommandWindow} />
                <button id="btnTriggerPopup" data-bs-toggle="modal" className='d-none' data-bs-target="#contextMenuModel" />
            </div>
        </div>;
    }
}

class ReeferHistorySearch {
    FromDate: string;
    ToDate: string;
    Units: string;
}

interface ReeferMasterStatus {
    UnitRCDAssociationHistoryID: number,
    LastParentEventID: number,
    ParentEventID: number,
    UnitMasterID: number,
    UnitPrefix: string,
    UnitNumber: string,
    ReeferID: string,
    UnitEventID: number,
    AlarmsList: string,
    CCAlarms: string,
    CCSeverityLevel: string,
    MicroAlarms: string,
    MASeverityLevel: string,
    UnitUSDAHistoryID: number,
    USDA1Temp: number,
    USDA2Temp: number,
    USDA3Temp: number,
    Cargo4Temp: number,
    O2Setpoint: number,
    CO2Setpoint: number,
    RunningMode: string,
    URH_UnitReadingsHistoryID: number,
    Humidity: number,
    UnitTypeCd: string,
    AmbientTemp: number,
    CompressorSuctionTemp: number,
    CompressorDischargeTemp: number,
    ReturnTemp1: number,
    SupplyTemp1: number,
    SupplyTemp2: number,
    ReturnTemp2: number,
    EvaporatorTemp: number,
    NumberOfAlarmsInQue: number,
    DischargePressure: number,
    CompositeSuctionPressure: number,
    VentPositionSensorCMH: number,
    PretripTestStateID: any,
    SetPoint: number,
    O2Reading: number,
    CO2Reading: number,
    TotalCurrentDraw: number,
    LowSpeedEvaporatorFanOutPut: string,
    HighSpeedEvaporatorFanOutPut: string,
    CondenserFanOutPut: string,
    HumiditySetpoint: number,
    SoftwareRevision: string,
    ControllerSerialNumber: string,
    CompressorFrequency: number,
    CondenserTemperature: number,
    CondenserPressure: number,
    HeaterOnTime: number,
    EvaporatorExpansionValveOpening: number,
    LineFrequency: number,
    DataLoggerDtm: string,
    TimeToDefrost: number,
    CurrentPhaseA: number,
    CurrentPhaseB: number,
    CurrentPhaseC: number,
    ThreePhaseCurrent: string,
    ReturnTempLongAvg: number,
    AmbientTempLongAvg: number,
    CompositeSuctionPressureLongAvg: number,
    DischargePressureLongAvg: number,
    SupplyTemperatureLongAvg: number,
    ReturnTemperatureLongAvg: number,
    CompressorSuctionTempLongAvg: number,
    CompressorCondensorTempLongAvg: number,
    RCDEventID: number,
    R_EventMasterID: number,
    R_ParentEventID: number,
    RCDMasterID: number,
    RCDMasterHistoryID: number,
    RCDGSMPositionHistoryID: number,
    RCDLocationHistoryID: number,
    RCDGPSPositionHistoryID: number,
    RCDStateReportedHistoryID: number,
    RCDAlarmSummaryHistoryID: number,
    R_EventDTTM: string,
    RunState: number,
    ControlledAtmosphereMode: string;
    R_RCDStateReportedHistoryID: number,
    IsAcceptableACVoltage: boolean,
    IsAcceptableBatteryVoltage: boolean,
    BatteryVoltage: number,
    RCDPowerSourceCd: string,
    ReeferACPowerLevel: number,
    ReeferOEMTypeCd: string,
    LineVoltage1: number,
    LineVoltage2: number,
    LineVoltage3: number,
    DeviceTemp: number,
    LastUnitEventID: number,
    EventMasterID: number,
    EventDTTM: any,
    ModifiedDTTM: any,
    U_UnitAlarmSummaryHistoryID: number,
    UnitControlEventID: number,
    C_EventDTTM: any,
    C_EventMasterID: number,
    C_ParentEventID: number,
    UnitVesselOperationsID: any,
    UnitCargoCareID: any,
    C_UnitAlarmSummaryHistoryID: any,
    Status: any,
    IsOnVessel: any,
    IsCargoCare: any,
    C_ModifiedDTTM: any,
    GeofenceName: string,
    RCDID: string,
    RCDFirmwareVersion: string,
    RCDBootloaderVersion: string,
    RCDMeshFirmwareVersion: string,
    RevisionNum: number,
    GPSLatitude: number,
    GPSLongitude: number,
    GPSLastLock: number,
    GPSCoords: string
    GPSLockState: string,
    IsInsideGeofence: boolean,
    Geofence: string,
    ActiveCommands: boolean,
    PendingCommands: boolean,
    ErrorCommands: boolean,
    CustomerAccessGroupIDList: string,
    TowerBaseStationID: number,
    TowerLocalizationAreaCode: number,
    MNC: number,
    SuctionModulationValveOpening: number,
    HotGasValveOpening: number,
    EconomizerValveOpening: number,
    RSSI: number,
    MSISDN: string,
    SIM_IMSI: string,
    ICCID: string,
    CompressorEvaporatorTempLongAvg: number,
    CompressorDischargeTempLongAvg: number,
    CountryCd: string,
    CountryName: string,
    UnitEventDTTM: any,
    PowerProfileCd: string,
    NotReportingFlag: number,
    PowerStateIsActive: boolean,
    PtiRunning: boolean,
    ControllerSerialNumberChgFlag: boolean,
    IsActiveAssociation: boolean,
    IsReeferCommunicationEstablished: boolean,
    UnitSettingsHistoryID: number,
    RCDReportingInterval: number,
    ReeferConfigTypeCd: string,
    Street: string,
    City: string,
    State: string,
    Zip: string,
    CustomerID: number,
    CustomerName: string,
    RCDRfrComErr: boolean,
    VesselID: string,
    VoyageID: string,
    PortOfDestination: string,
    PortOfDeparture: string,
    TripId: number,
    TripStatusCd: string,
    TripStatusCdAndDFlag: string,
    DeviationFlg: boolean,
    TripDefStatusDsc: string,
    TripNameAndStatus: string,
    TripRouteWaypointId: number,
    BookedTemperature: number,
    BookingNumber: string,
    TemperatureUnit: string,
    CommentExists: number,
    ErrorMessage: string
}

//WI-23853
enum GensetAndDryAndChassisStatusEnum {
    PowerOnReporting = 12,
    PowerOnNotReporting = 13,
    PowerOffReporting = 14,
    PowerOffNotReporting = 15,
    DryInGeofence = 16,
    DryOutGeofence = 17,

    ChassisPwrInGeofence = 18,
    ChassisPwrOutGeofence = 19,
    ChassisNotPwrInGeofence = 20,
    ChassisNotPwrOutGeofence = 21
}